<template>
  <div id="map_container" @drop="onDropFile" @dragover.prevent>
    <div
      v-if="enableMapLoading"
      id="mapLoading"
      style="
        z-index: 999999;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        width: 100%;
      "
    >
      <v-progress-circular
        style="
          margin: 0;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        color="white"
        indeterminate
      ></v-progress-circular>
    </div>

    <ImportDialog :core="core" :tour="tour" ref="import"></ImportDialog>

    <ExportDialog :core="core" :tour="tour" ref="export"></ExportDialog>

    <SaveDialog :core="core" ref="saveDialog"></SaveDialog>

    <LeftBar :core="core" :tour="tour" ref="leftBar" id="leftBar" :leftBarWidth="leftBarWidth" :leftBarHeight="leftBarHeight" />

    <LeftBarAddNCopyDialog
      :core="core"
      ref="leftBarAddNCopy"
      id="leftBarAddNCopy"
    ></LeftBarAddNCopyDialog>

    <Tour id="tour" ref="tour"></Tour>
    <Tour2 :core="core" class="tour2" ref="tour2"></Tour2>

    <div id="map" ref="map"></div>

    <div id="olMap" ref="olMap"></div>

    <IntroVideo :core="core" ref="introVideo"></IntroVideo>

    <WelcomeDialog :core="core" :app="this"></WelcomeDialog>

    <About :core="core" :app="this"></About>



    <v-btn
      @mousedown="leftBarSliderDrag($event)"
      @touchstart="leftBarSliderDrag($event)"
      small
      :title="$t('common.title_leftBarSliderDrag')"
      id="leftBarSlider"
      ref="leftBarSlider"
      fab
      v-if="showLeftBar"
    >
      <v-icon>mdi-arrow-split-vertical</v-icon>
    </v-btn>

    <div
      id="map_tools"
      ref="map_tools"
      :class="tableWidthSize != 'xs' ? 'no_background' : ''"
      :style="`z-index: 1000; ${tableWidthSize == 'xs' ? 'margin-top:9px;' : ''}`"
    >
      <!-- <template v-if="tableWidthSize != 'xs'"> -->
      <template v-if="tableWidthSize == 'xs'">
        <v-menu
          offset-y
          nudge-top="-10"
          v-model="map_tools_visible"
          :close-on-click="map_tools_close_on_click"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-apps</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item dense
              ><SaveButton :core="core" ref="save"></SaveButton></v-list-item
          ></v-list>
          <v-list
            ><v-list-item dense
              ><ImportButton :core="core" ref="importButton" /></v-list-item
          ></v-list>
          <v-list
            ><v-list-item dense
              ><ExportButton :core="core" ref="exportButton" /></v-list-item
          ></v-list>
        </v-menu>
      </template>
      <template v-else>
        <div>
          <SaveButton :core="core" ref="save"></SaveButton>
        </div>
        <div>
          <ImportButton :core="core" ref="importButton" />
        </div>
        <div>
          <ExportButton :core="core" ref="exportButton" />
        </div>
      </template>
    </div>

    <LTable ref="table_container" :core="core"></LTable>

    <SearchBar
      :core="core"
      :map="map"
      id="searchBar"
      ref="searchBar"
      @customFetch="customFetch"
    />

    <v-dialog
      width="400"
      maxWidth="90%"
      :persistent="true"
      :style="`z-index: ${this.confirmationIndex};position: fixed;`"
      v-model="confirmDialog"
    >
      <v-card>
        <v-toolbar dark color="primary"
          ><v-icon v-if="confirmDialogWarningTitleIcon" color="red">warning</v-icon
          >{{ confirmDialogTitle ? confirmDialogTitle : $t("common.confirm") }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              confirmDialogCancel ? confirmDialogCancel() : null;
              confirmDialog = false;
            "
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-title></v-card-title>

        <v-card-text v-html="confirmDialogMessage"></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            text
            @click="
              confirmDialogCancel ? confirmDialogCancel() : null;
              confirmDialog = false;
            "
            >{{ $t("common.cancel") }}</v-btn
          >
          <v-btn
            large
            color="primary"
            v-if="confirmDialogOK"
            @click="
              confirmDialogOK();
              confirmDialog = false;
            "
            >{{ $t("common.ok") }}</v-btn
          >
          <v-btn
            v-if="confirmDialogCustom || confirmDialogCustom"
            large
            color="error"
            @click="
              confirmDialogCustom();
              confirmDialog = false;
            "
            >{{ $t("common.clearConvertDataFailed") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<!--<script src="https://unpkg.com/leaflet@1.7.1/dist/leaflet.js"></script>-->
<script src="<%= BASE_URL %>lib/leaflet.js"></script>

<script>
import * as GLOBAL from "./Global.js";
import {
  CustomViewPointControl,
  CustomSwitchLayersControl,
} from "./CustomLeafletControl.js";

import About from "./About.vue";

import WelcomeDialog from "./WelcomeDialog.vue";
import IntroVideo from "./IntroVideo.vue";
import ImportDialog from "./ImportDialog.vue";
import ImportButton from "./ImportButton.vue";
import ExportDialog from "./ExportDialog.vue";
import ExportButton from "./ExportButton.vue";
import LeftBarAddNCopyDialog from "./LeftBarAddNCopyDialog.vue";
import SaveButton from "./SaveButton.vue";
import SaveDialog from "./SaveDialog.vue";
import EditField from "./EditField.vue";
import SearchBar from "./SearchBar.vue";
import LeftBar from "./LeftBar";
import Tour from "./Tour.vue";
import Tour2 from "./Tour2.vue";
import LTable from "./Table.vue";

import localforage from "localforage";

//openlayer
import { Map, View } from "ol";
import { register } from "ol/proj/proj4";

function defineProj4(proj4, name, code) {
  proj4.defs("EPSG:" + name, code);
  proj4.defs("EPSG::" + name, code);
  proj4.defs("http://www.opengis.net/gml/srs/epsg.xml#" + name, code);
  proj4.defs("urn:x-ogc:def:crs:EPSG:" + name, code);
  proj4.defs("urn:ogc:def:crs:EPSG::" + name, code);

  // qgis special format
  if (name == "4326") {
    proj4.defs["OGC:CRS84"] = proj4.defs["EPSG:4326"];
  }

  //for lib ol
  ol.proj.proj4.register(proj4);

  //for npm ol
  register(proj4);

  let proj = null;

  proj = new ol.proj.Projection({ code: "EPSG:" + name, axis: "neu" });
  ol.proj.addEquivalentProjections([ol.proj.get("EPSG:" + name), proj]);

  proj = new ol.proj.Projection({ code: "EPSG::" + name, axis: "neu" });
  ol.proj.addEquivalentProjections([ol.proj.get("EPSG:" + name), proj]);

  proj = new ol.proj.Projection({
    code: "http://www.opengis.net/gml/srs/epsg.xml#" + name,
    axis: "neu",
  });
  ol.proj.addEquivalentProjections([ol.proj.get("EPSG:" + name), proj]);
}

//projection setting
defineProj4(
  proj4,
  "2326",
  "+proj=tmerc +lat_0=22.31213333333334 +lon_0=114.1785555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.24365,-1.15883,-1.09425 +units=m +no_defs"
);
defineProj4(
  proj4,
  "4326",
  "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"
);

export default {
  name: "Map",

  components: {
    Tour,
    Tour2,
    WelcomeDialog,
    About,
    ExportButton,
    ImportButton,
    LeftBarAddNCopyDialog,
    IntroVideo,
    ImportDialog,
    ExportDialog,
    SaveButton,
    SaveDialog,
    EditField,
    SearchBar,
    LeftBar,
    LTable,
  },

  props: [
    "app",
    "enableLeftBarTabs",
    "enableLeftBarTabsTouch",
    "enablePrint",
    "enableAttachRefLayer",
    "enableAddDynamicLayer",
    "enableCurrentLocation",
    "locate",
    "showNewSnackBar",
    "closeNewSnackBar",
    "setSavedMessage",
    // "loadLocalStorageSpace",
    "rules",
    "indexlabelBaseMap",
    "indexOverLay",
    "indexDrawnItem",
    "leftBarIndex",
    "confirmationIndex",
    "errorMessageIndex",
    "showLayerMessageSnackbar",
    "closeLayerMessageSnackbar",
  ],

  data() {
    return {
      GLOBAL: GLOBAL,

      introVideo: {
        visible: false,
      },

      frontBanner: {
        visible: true,
      },

      aboutDialog: false,
      welcomeDialog: false,

      //map tools
      map_tools_visible: false,
      map_tools_close_on_click: true,

      proj4: proj4,
      core: this,
      searchBar: null,
      leftBar: null,
      import: null,
      importButton: null,
      export: null,
      exportButton: null,
      save: null,
      saveDialog: null,
      notsaveDialog: null,
      map: null,
      table_container: null,

      minZoom: 11,

      maxBounds: new L.LatLngBounds(
        new L.LatLng(22.742623, 113.520355),
        new L.LatLng(21.868508, 114.863434)
      ),

      mapDefaultExtent: [22.36690308920919, 114.12282690512912],

      //width & height
      // leftBarWidth: $(document).width() * 0.6,
      leftBarSliderWidthPercent: 0,
      tableSliderHeightPercent: 0,
      tableWidthSize: "xs",
      leftBarWidthSize: "xs",

      //FeatureGroups
      drawnItems: null,
      dynamicLayerDrawnItems: null,
      identifyMainDrawnItems: null,
      identifyResultDrawnItems: null,
      tableItemsRefLayerDrawnItems: null,
      searchResultDrawnItems: null,

      //Enable Identify then disable table item add item
      enableIdentify: true,
      //Enable Identify for Table Item
      enableIdentifyTableItemMarker: false,
      enableIdentifyTableItemSubLayer: false,
      //Enable Print Custom
      enablePrintCustom: false,
      //Enable Whether Show Input Special Type Dialog
      enableShowInputSpecialTypeDialog: false,
      //For Enable Auto-Save
      enableStartSaveToLocalStorage: false,
      enableSaveToLocalStorage: false,
      //For Enable Map Loading
      enableMapLoading: false,

      //For Search Result - Selected Item
      currentSelectedSearchResultLeafletId: null,
      //For Table Item - Selected Item
      currentSelectedTableItem: null,
      //For Dynamic Field - Delete
      currentDeleteDynamicField: null,
      //For Current Selected Table Item Column
      currentSelectedTableItemColumn: null,

      //Dynamic Layers by User
      dynamicLayers: [],

      //Confirmation Dialog Variables
      confirmDialog: false,
      confirmDialogTitle: "",
      confirmDialogWarningTitleIcon: false,
      confirmDialogMessage: "",
      confirmDialogOK: null,
      confirmDialogCancel: null,
      confirmDialogCustom: null,
      confirmDialogCustomTitle: "",
      confirmDialogPersistent: false,

      //Layers Variables
      topoLayer: null,
      orthoLayer: null,
      lotLayer: null,
      lotLayerQuery: null,
      buildingLayer: null,
      buildingLayerQuery: null,
      labelBaseMap: null,
      // identifyLot: null,
      // identifyGla: null,

      //SearchResult Variable
      showLeftBar: false,

      //Import
      batchLocationSearchOnlyMatchResultItems: 3, //match coordinates when number of query result items is less or equal these number
      batchLocationSearchMaxCSVItems: 100, //import csv with auto match field is only available for less these number
      batchLocationSearchLimitDistanceMeters: 100, //import csv with auto match field is only available for distance range

      // Data Table Variable
      showTable: false,
      tableItems: [],
      dynamicFields: [],
      tableSortKey: null,
      defaultDynamicFields: GLOBAL.DEFAULT_DYNAMIC_FIELDS,
      filterKeyword: null,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 20, 50, 100, 200, 500, 1000],
      datePickerMenuModel: {},

      // Data Table Settings
      options: {
        search: true,
      },

      //Data Table Dialogs
      deleteDataModal: false,
      manageColumnModal: false,
      // New Columan Name Dialog
      newColumnName: "",
      newColumnNameState: null,
      newColumnNameError: "",

      //Leaflet Controls
      layersControl: null,
      scaleControl: null,
      locateControl: null,
      browserPrintControl: null,
      drawControl: null,
      searchBar: null,
      customSwitchLayersControl: null,
      customAttributionControl: null,
      zoomControl: null,
      customViewPointControl: null,

      //Timer
      resizeTimer: null,

      //Add and New Copy Dialog
      matchingDialog: {
        visible: false,
        isCopy: false,
        data: {},
        showAdvanced: false,
      },

      //Tour
      tour: null,
      tour_intervalID: null,
      notAllowBackdropClose: false,
      notShowTableTour: false,

      //Tour 2
      tour2: null,

      layerName: "geotagging",
    };
  },

  watch: {
    //clear other specific command
    filterKeyword(newVal, oldVal) {
      if (newVal != oldVal) {
        let items = newVal.filter((item) => {
          switch (item) {
            case GLOBAL.FILTER_COMMEND.AUTOMATCHED:
            case GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY:
            case GLOBAL.FILTER_COMMEND.NONGEOTAGGED:
            case GLOBAL.FILTER_COMMEND.GEOTAGGED:
              return true;
            default:
              return false;
          }
        });

        if (items.length > 1) {
          this.core.filterKeyword = newVal.filter((item) => {
            for (let i = 0; i < items.length - 1; i++) {
              if (item == items[i]) {
                return false;
              } else {
                return true;
              }
            }
          });
        }
      }
    },

    async showLeftBar(newVal) {
      //hide and show leftBar's layers
      if (newVal) {
        // this.map.addLayer(this.drawnItems);
        this.map.addLayer(this.searchResultDrawnItems);
        this.map.addLayer(this.identifyMainDrawnItems);
        this.map.addLayer(this.identifyResultDrawnItems);

        // Show Search Result Panel tour when it is shown for the first time
        if (
          this.showLeftBar &&
          (await localforage.getItem("showIdentifyTour")) !== false
        ) {
          $(".v-btn").prop("disabled", true);
          setTimeout(() => {
            this.leftBar.searchResult && this.leftBar.searchResult.length == 0
              ? this.tour2.runLeftBarTourSteps({ emptyRecord: true })
              : this.tour2.runLeftBarTourSteps({});
            localforage.setItem("showIdentifyTour", false);
            if ($(".driver-fix-stacking")[0] == undefined) {
              $(".v-btn").removeAttr("disabled");
            }
          }, 1100);
        }
      } else {
        // this.map.removeLayer(this.drawnItems);
        this.map.removeLayer(this.searchResultDrawnItems);
        this.map.removeLayer(this.identifyMainDrawnItems);
        this.map.removeLayer(this.identifyResultDrawnItems);
      }
    },

    currentPage(newVal) {
      if (newVal && newVal > this.numOfPage) {
        this.$nextTick(() => {
          this.currentPage = this.numOfPage ? this.numOfPage : 1;
        });
      }
    },

    numOfPage(newVal) {
      if (this.currentPage > this.numOfPage) {
        this.$nextTick(() => {
          this.currentPage = this.numOfPage ? this.numOfPage : 1;
        });
      }
    },

    leftBarSliderWidthPercent(newVal, oldVal) {
      //hidden 20210203 tedngok
      //close left bar when smaller then special width
      // if (newVal != oldVal && newVal <= 150) {
      //   this.leftBarSliderWidthPercent = 0;
      //   this.showLeftBar = false;
      // }
    },

    tableSliderHeightPercent(newVal, oldVal) {
      // console.log("tableSliderHeightPercent", newVal, oldVal);
      if (newVal != oldVal && newVal <= 10) {
        this.tableSliderHeightPercent = 0;
        this.showTable = false;
        this.resizeElements(0);
      }
    },

    async showTable(newVal) {
      if (newVal) {
        //skip open tour for some cases
        if (this.notShowTableTour) {
          this.notShowTableTour = false;
          return;
        }

        if ((await localforage.getItem("showTableTour")) !== false) {
          setTimeout(() => {
            this.tour2.runTableTourSteps();
            localforage.setItem("showTableTour", false);
          }, 500);
        }
      }
    },

    async manageColumnModal(newVal) {
      //reset New Column Name
      if (this.$refs.newColumnNameForm && this.$refs.newColumnNameForm.reset) {
        this.$refs.newColumnNameForm.reset();
      }

      let me = this;
      if (newVal) {
        // Avoid closing dialog quickly problem when tour is running
        // Check if auto tour is needed to be run
        if ((await localforage.getItem("showColumnSettingTour")) !== false) {
          localforage.setItem("showColumnSettingTour", false);
          this.notAllowBackdropClose = true;
          if (me.tour2) {
            me.tour2.runColumnSettingsTourSteps();
          }
          this.setDialogPersistent();
        }
        this.table_container.layerName = this.core.layerName;
      }

      // if (this.$refs.newColumnNameForm && this.$refs.newColumnNameForm.resetValidation) {
      //   this.$refs.newColumnNameForm.resetValidation();
      // }
    },

    enableIdentify(val) {
      if (val) {
        this.enableIdentifyTableItemMarker = false;
        this.enableIdentifyTableItemSubLayer = false;
        this.enablePrintCustom = false;

        //enable draw tool
        this.closeLayerMessageSnackbar();
        this.resetDrawTool();
        this.showDrawTool(true);
        this.resetPrintTool();
        this.showPrintTool(true);
      }
    },

    enableIdentifyTableItemMarker(val) {
      let me = this;
      if (val) {
        //disable & hidden draw tool
        this.showDrawTool(false);
        this.resetDrawTool();
        this.showPrintTool(false);
        this.resetPrintTool();

        $("a.leaflet-draw-draw-marker")[0].click();

        this.enableIdentify = false;
        me.chgShowLeftBar(false);

        this.showLayerMessageSnackbar(
          this.$t("common.addMarkerByClickMapMessage"),
          () => {
            me.enableIdentify = true;
          }
        );
      } else {
        this.enableIdentify = true;
      }
    },

    enableIdentifyTableItemSubLayer(val) {
      let me = this;
      if (val) {
        //disable & hidden draw tool
        this.showDrawTool(false);
        this.resetDrawTool();
        this.showPrintTool(false);
        this.resetPrintTool();

        this.enableIdentify = false;
        this.showLayerMessageSnackbar(
          this.$t("common.addBuildingLayerByClickMapMessage"),
          () => {
            me.enableIdentify = true;
          }
        );
      } else {
        this.enableIdentify = true;
      }
    },

    enablePrintCustom(val) {
      let me = this;
      if (val) {
        //disable & hidden draw tool
        this.showDrawTool(false);
        this.resetDrawTool();
        this.enableIdentify = false;

        this.showLayerMessageSnackbar(this.$t("common.printCustomMessage"), () => {
          // console.log("map", me.map);
          // console.log("control", me.browserPrintControl);
          me.enablePrintCustom = false;

          //close custom print
          me.browserPrintControl._clearPrint();
          me.map.off(
            "mousedown",
            me.browserPrintControl._startAutoPoligon,
            me.browserPrintControl
          );
        });
      } else {
        this.enableIdentify = true;
      }
    },

    locate(val) {
      this.updateWebTitle();

      this.removeControl();
      this.initControl();
    },

    //it support drawnitem and layer
    currentSelectedTableItem(newVal, oldVal) {
      let layer = null;

      // if (!this.enableIdentify) {
      //   return false;
      // }

      if (oldVal && oldVal.leaflet_id) {
        layer = this.map._layers[oldVal.leaflet_id];
        if (layer) {
          switch (layer.feature.geometry.type) {
            case "Point":
              layer.setIcon(L.icon(GLOBAL.LEAFLET.BLUE_ICON));
              layer._resetZIndex();
              break;
            case "Polygon":
              layer.setStyle(this.GLOBAL.LAYER_STYLE.TABLE_LAYER);
              layer.bringToBack();
              break;
            default:
              break;
          }
        }

        if (oldVal.refLayer) {
          let refLayer = this.map._layers[oldVal.refLayer.leaflet_id];
          if (refLayer) {
            refLayer.setStyle(this.GLOBAL.LAYER_STYLE.TABLE_LAYER);
            refLayer.bringToBack();
          }
        }
      }

      if (newVal && newVal.leaflet_id) {
        layer = this.map._layers[newVal.leaflet_id];
        if (layer) {
          switch (layer.feature.geometry.type) {
            case "Point":
              // layer.setIcon(L.icon(GLOBAL.LEAFLET.GOLD_ICON));
              layer.setIcon(L.icon(GLOBAL.LEAFLET.RED_ICON));
              break;
            case "Polygon":
              layer.setStyle(this.GLOBAL.LAYER_STYLE.TABLE_ITEM_LAYER_SELECTED);
              break;
            default:
              break;
          }

          if (layer.bringToFront) {
            layer.bringToFront();
          } else if (layer._bringToFront) {
            layer._bringToFront();
          }
        }

        if (newVal.refLayer) {
          let refLayer = this.tableItemsRefLayerDrawnItems.getLayer(
            newVal.refLayer.leaflet_id
          );
          if (refLayer) {
            refLayer.setStyle(this.GLOBAL.LAYER_STYLE.TABLE_ITEM_LAYER_SELECTED);
            refLayer.bringToFront();
          }
        }
      }
    },

    tableItems(val) {
      //empty currentSelectedTableItem if no table item match
      if (this.currentSelectedTableItem) {
        let result = val.find((tableItem) => {
          if (this.currentSelectedTableItem == tableItem) {
            return true;
          }
        });

        if (!result) {
          // this.currentSelectedTableItem = null;
          this.updateCurrentSelectedTableItem({ tableItem: null });
        }
      }

      this.saveDataToLocalStorage();
    },

    dynamicLayers(val) {
      this.saveDataToLocalStorage();
    },

    dynamicFields(val) {
      this.saveDataToLocalStorage();
    },

    enableSaveToLocalStorage() {
      this.saveDataToLocalStorage();
    },
  },

  computed: {
    totalRows() {
      return this.filteredItems.length;
    },

    numOfPage() {
      return Math.ceil(this.totalRows / this.perPage);
    },
    validNewColumnNameState() {
      if (this.newColumnName == null || this.newColumnName == "") {
        return false;
      } else {
        let fields = this.fields;
        for (let i = 0; i < fields.length; i++) {
          //is existing message
          if (
            fields[i].label &&
            fields[i].label.toLowerCase().trim() ==
              this.newColumnName.toLowerCase().trim()
          ) {
            return this.$t("common.colNameIsExistingMessage");
            break;
          }

          //system used label
          let hidden_field_labels = Object.entries(GLOBAL.HIDDEN_FIELD_LABELS);
          for (let i = 0; i < hidden_field_labels.length; i++) {
            const [key, value] = hidden_field_labels[i];
            if (value.toLowerCase().trim() == this.newColumnName.toLowerCase().trim()) {
              return this.$t("common.colNameIsExistingSystemUsedMessage");
              break;
            }
          }
        }

        return true;
      }
    },

    // filtering function
    filteredItems() {
      let filterKeyword = this.filterKeyword;

      return filterKeyword && filterKeyword.length > 0
        ? this.tableItems.filter(function (item) {
            let properties = [];
            let showItem = true;

            try {
              properties = item.geojson.properties;
            } catch (e) {
              try {
                properties = item.item;
              } catch (e) {
                console.log(e);
              }
            }

            for (let i = 0; i < filterKeyword.length; i++) {
              if (
                filterKeyword[i].toUpperCase() ==
                  GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase() &&
                (item.leaflet_id != null || item.geojson != null)
              ) {
                showItem = false;
              } else if (
                filterKeyword[i].toUpperCase() ==
                  GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase() &&
                (item.leaflet_id == null || item.geojson == null)
              ) {
                showItem = false;
              } else if (
                filterKeyword[i].toUpperCase() ==
                  GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase() &&
                !item.automatched
              ) {
                showItem = false;
              } else if (
                filterKeyword[i].toUpperCase() ==
                  GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase() &&
                !item.automatchedxy
              ) {
                showItem = false;
              }
            }

            if (!showItem) {
              return false;
            }

            let isMatchKeyword = true;
            for (let i = 0; i < filterKeyword.length; i++) {
              if (
                filterKeyword[i].toUpperCase() !=
                  GLOBAL.FILTER_COMMEND.NONGEOTAGGED.toUpperCase() &&
                filterKeyword[i].toUpperCase() !=
                  GLOBAL.FILTER_COMMEND.AUTOMATCHED.toUpperCase() &&
                filterKeyword[i].toUpperCase() !=
                  GLOBAL.FILTER_COMMEND.AUTOMATCHEDXY.toUpperCase() &&
                filterKeyword[i].toUpperCase() !=
                  GLOBAL.FILTER_COMMEND.GEOTAGGED.toUpperCase()
              ) {
                let tmpIsMatchKeyword = false;

                for (let propertyKey in properties) {
                  let testString = (properties[propertyKey] + "").toUpperCase();

                  if (testString.search(filterKeyword[i].toUpperCase()) > -1) {
                    tmpIsMatchKeyword = true;
                    break;
                  }
                }

                isMatchKeyword = isMatchKeyword && tmpIsMatchKeyword;
              }
            }

            showItem = isMatchKeyword;

            return showItem;
          })
        : this.tableItems;
    },

    fields() {
      let result = [];

      //default index column
      result.push({
        key: GLOBAL.HIDDEN_FIELD_LABELS.INDEX,
        label: this.tableItems.length > 0 ? this.$t("common.indexFieldTitle") : "",
        sortable: true,
        stickyColumn: true,
        isRowHeader: true,
      });

      for (let i = 0; i < this.dynamicFields.length; i++) {
        if (
          this.GLOBAL.HIDDEN_FIELD_LABELS.hasOwnProperty(this.dynamicFields[i]["label"])
        ) {
          continue;
        } else if (this.isNotHiddenField(this.dynamicFields[i]["label"])) {
          result.push(this.dynamicFields[i]);
        }
      }

      return result;
    },
  },

  async created() {
    //import environment setting
    //enable savetolocalstorage when there is no variable

    this.enableSaveToLocalStorage =
      (await localforage.getItem("enableSaveToLocalStorage")) ||
      this.enableSaveToLocalStorage;

    //Show welcome dialog
    if (
      //localStorage.getItem("showWelcome") == null || localStorage.getItem("showWelcome") !== false
      (await localforage.getItem("showWelcome")) == null ||
      (await localforage.getItem("showWelcome")) !== false
      // $cookies.get("showWelcome") == null || $cookies.get("showWelcome") !== false
    ) {
      this.welcomeDialog = true;
    }

    if (
      this.enableSaveToLocalStorage &&
      (await this.isExistingLocalStorageAndImportData(false))
    ) {
      this.showLoadDataModal();
    } else if (!this.enableSaveToLocalStorage) {
      // this.tour2.runMapTourSteps({});
      this.clearLocalStorage();
    } else {
      // this.tour2.runMapTourSteps({});
    }
    this.enableStartSaveToLocalStorage = true;
  },

  async mounted() {
    let me = this;

    this.app.map = this;

    this.init();

    this.initControl();

    //resize elements first
    this.setResizeElementTimer(0);
    //resize when window resizeF
    $(window).resize(() => {
      this.setResizeElementTimer(0);
    });

    this.import = this.$refs.import;
    this.importButton = this.$refs.importButton;
    this.save = this.$refs.save;
    this.export = this.$refs.export;
    this.exportButton = this.$refs.exportButton;
    this.leftBar = this.$refs.leftBar;
    this.searchBar = this.$refs.searchBar;
    this.table_container = this.$refs.table_container;

    this.tour = this.$refs.tour;
    this.tour2 = this.$refs.tour2;
  },

  methods: {

    showMapLoading() {
      this.enableMapLoading = true;
    },

    closeMapLoading() {
      this.enableMapLoading = false;
    },

    leftBarWidth() {
      if (!this.showLeftBar) {
        return 0
      } else {
        return (this.leftBarSliderWidthPercent * $(window).width()) / 100
              ? (this.leftBarSliderWidthPercent * $(window).width()) / 100
              : 
              $(document).width() * 0.45 < 408 ? $(document).width() * 0.45 : 408
      }
    },

    leftBarHeight() {
      // console.log($(window).height() , $("#appBar").height())
      return $(window).height() - $("#appBar").height();
    },

    leftBarMaxWidth() {
      return $(window).width() * (this.$vuetify.breakpoint.name != "xs" ? 0.4 : 1);
    },

    leftBarMinWidth() {
      return this.$vuetify.breakpoint.name != "xs" ? 335 : 180;
    },
    updateWebTitle() {
      $(document).attr("title", this.$t("common.appNameWebTitle"));
    },

    updateCurrentSelectedTableItem({ tableItem, forceUpdate }) {
      let _forceUpdate = forceUpdate || false;

      this.currentSelectedTableItem = null;

      if (forceUpdate) {
        // this.currentSelectedTableItem = null;
        this.currentSelectedTableItem = tableItem;
        return true;
      } else if (!this.enableIdentify) {
        return false;
      } else {
        this.currentSelectedTableItem = tableItem;
      }
    },

    tableRowClass(item, type) {
      if (type == "row") {
        // console.log(item);
        if (item == this.core.currentSelectedTableItem) {
          return "selectedTableItem";
        } else if (!item.leaflet_id) {
          // return "emptyLocationTableItem";
        }
      }
    },

    createTableMarkerOnly(latLng, properties) {
      return L.geoJSON({
        type: "Feature",
        properties: {
          ...properties,
        },
        geometry: {
          type: "Point",
          coordinates: [latLng.lng, latLng.lat],
        },
      }).getLayers()[0];
    },

    createTableMarker(latLng, properties) {
      let markerLayer = this.createTableMarkerOnly(latLng, properties);
      this.attachDrawnMarkerToMap(markerLayer);
      return markerLayer;
    },

    returnFalse() {
      return false;
    },
    existingSpecialFieldTypes() {
      let result = this.dynamicFields.filter((dynamicField) => {
        if (
          dynamicField.type == GLOBAL.FIELD_TYPES.ADDRESS_ZH ||
          dynamicField.type == GLOBAL.FIELD_TYPES.ADDRESS_EN ||
          dynamicField.type == GLOBAL.FIELD_TYPES.NAME_ZH ||
          dynamicField.type == GLOBAL.FIELD_TYPES.NAME_EN
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (result.length == 4) {
        return true;
      } else {
        return false;
      }
    },

    leftBarSliderDrag(event) {
      let me = this,
        // startClientX = event.clientX || event.touches[0].clientX,
        endClientX = null;
      //console.log(event)

      if (event.touches) {
        document.ontouchmove = function (ev) {
          //console.log(ev)
          endClientX = ev.touches[0].clientX;
          // $("#leftBarSlider").css({
          //   left:
          //     endClientX > me.leftBarMaxWidth ? me.leftBarMaxWidth : endClientX,
          // });

          if (me.leftBarMinWidth < endClientX && endClientX < me.leftBarMaxWidth) {
            $("#leftBarSlider").css({
              left: endClientX,
            });
          }
        };

        document.ontouchend = function () {
          if (endClientX) {
            me.leftBarSliderWidthPercent =
              ((endClientX + $("#leftBarSlider").width() / 2) / $(window).width()) * 100;

            $("#leftBar").css({
              width: (me.leftBarSliderWidthPercent * $(window).width()) / 100,
            });
          }

          document.ontouchmove = null;
          document.ontouchend = null;

          me.resizeElements(0);
        };
        return;
      }

      document.onmousemove = function (ev) {
        //console.log(ev)
        endClientX = ev.clientX;

        if (me.leftBarMinWidth < endClientX && endClientX < me.leftBarMaxWidth) {
          $("#leftBarSlider").css({
            left: endClientX,
          });
        }
      };

      document.onmouseup = function () {
        if (endClientX) {
          me.leftBarSliderWidthPercent =
            ((endClientX + $("#leftBarSlider").width() / 2) / $(window).width()) * 100;

          $("#leftBar").css({
            width: (me.leftBarSliderWidthPercent * $(window).width()) / 100,
          });
        }

        document.onmousemove = null;
        document.onmouseup = null;

        me.resizeElements(0);
      };

      return false;
    },

    tableSliderDrag(event) {
      let me = this,
        startClientY = event.clientY || event.touches[0].clientY,
        endClientY = null;

      //touch event (mobile)
      if (event.touches) {
        document.ontouchmove = function (ev) {
          endClientY = ev.touches[0].clientY;

          // console.log(me.showLeftBar);
          // console.log($("#leftBar").width());

          $("#tableSlider").css({
            position: "fixed",
            left:
              (me.showLeftBar ? $("#leftBar").width() : 0) +
              $("#data_container").width() / 2,
            top: endClientY,
          });
        };

        document.ontouchend = function () {
          if (endClientY) {
            $("#tableSlider").css({
              position: "absolute",
              top: -$("#tableSlider").height() / 2,
              left: "50%",
            });

            let resizedHeight =
              $("#data_content").height() -
              (endClientY - startClientY) -
              $("#tableSlider").height() / 2;

            if (resizedHeight > $("#leftBar").height()) {
              resizedHeight = $("#leftBar").height();
            }

            me.tableSliderHeightPercent = (resizedHeight / $(window).height()) * 100;
            // console.log(resizedHeight);

            let data_content =
              (me.tableSliderHeightPercent * $(window).height()) / 100 >
              $(window).height() - $("#appBar").height() - 24
                ? $(window).height() - $("#appBar").height() - 24
                : (me.tableSliderHeightPercent * $(window).height()) / 100;

            $("#data_content").css({
              height: data_content,
            });

            $("#map").css({
              height:
                $(window).height() -
                $("#appBar").height() -
                $("#data_container").height(),
            });
            me.map.invalidateSize();
            // me.resizeElements()
          }

          document.ontouchmove = null;
          document.ontouchend = null;

          me.resizeElements(0);
        };

        return;
      }

      //mouse event

      document.onmousemove = function (ev) {
        endClientY = ev.clientY;

        // console.log(me.showLeftBar);
        // console.log($("#leftBar").width());

        $("#tableSlider").css({
          position: "fixed",
          left:
            (me.showLeftBar ? $("#leftBar").width() : 0) +
            $("#data_container").width() / 2,
          top: endClientY,
        });
      };

      document.onmouseup = function () {
        if (endClientY) {
          $("#tableSlider").css({
            position: "absolute",
            top: -$("#tableSlider").height() / 2,
            left: "50%",
          });

          let resizedHeight =
            $("#data_content").height() -
            (endClientY - startClientY) -
            $("#tableSlider").height() / 2;

          if (resizedHeight > $("#leftBar").height()) {
            resizedHeight = $("#leftBar").height();
          }

          me.tableSliderHeightPercent = (resizedHeight / $(window).height()) * 100;
          // console.log(resizedHeight);

          let data_content =
            (me.tableSliderHeightPercent * $(window).height()) / 100 >
            $(window).height() - $("#appBar").height() - 24
              ? $(window).height() - $("#appBar").height() - 24
              : (me.tableSliderHeightPercent * $(window).height()) / 100;

          $("#data_content").css({
            height: data_content,
          });

          $("#map").css({
            height:
              $(window).height() - $("#appBar").height() - $("#data_container").height(),
          });
          me.map.invalidateSize();
          // me.resizeElements()
        }

        document.onmousemove = null;
        document.onmouseup = null;

        me.resizeElements(0);
      };

      return false;
    },

    getTableItemByLeafletId(leaflet_id) {
      return this.tableItems.find((tableItem) => tableItem.leaflet_id == leaflet_id);
    },

    checkIntersects(featureGroup, callback) {
      try {
        let layers = featureGroup.getLayers(),
          result = true;

        for (let i = 0; i < layers.length; i++) {
          let layer = layers[i];

          if (layer.getLatLng) {
            result = this.maxBounds.intersects(new L.LatLngBounds([layer.getLatLng()]));
          } else if (layer.getLayers && layer.getLayers().length > 0) {
            result = this.maxBounds.intersects(layer.getBounds());
          } else {
            // console.log(layer);
          }

          // console.log(result);

          if (!result) {
            break;
          }
        }

        if (result) {
          callback();
        } else {
          this.clearConfirmDialog();
          this.confirmDialogMessage = this.$t("common.importDialog.notAtHKMessage");
          this.confirmDialogOK = () => {
            callback();
          };
          this.confirmDialog = true;
        }
      } catch (e) {
        console.log(e);
        failCallback();
      }
    },

    showPrintTool(showOrNot) {
      if (showOrNot) {
        $(".leaflet-browser-print").show();
      } else {
        $(".leaflet-browser-print").hide();
      }
    },

    showDrawTool(showOrNot) {
      if (showOrNot) {
        $(".leaflet-draw").show();
      } else {
        $(".leaflet-draw").hide();
      }
    },

    resetPrintTool() {},

    resetDrawTool() {
      this.drawControl._toolbars.draw.disable();
      this.drawControl._toolbars.edit.disable();
    },

    getXYByLeafletId(leaflet_id) {
      let layer = this.map._layers[leaflet_id];
      // console.log(layer)
      if (layer && layer.getLatLng) {
        return layer.getLatLng();
      } else {
        // console.log(layer);
        return null;
      }
    },

    displayLat(lat, showUnit) {
      return lat ? lat.toFixed(4) + (showUnit ? "° N" : "") : "";
    },
    displayLng(lng, showUnit) {
      return lng ? lng.toFixed(4) + (showUnit ? "° E" : "") : "";
    },
    displayHK80X(x, showUnit) {
      return x ? x.toFixed(1) + (showUnit ? "" : "") : "";
    },
    displayHK80Y(y, showUnit) {
      return y ? y.toFixed(1) + (showUnit ? "" : "") : "";
    },

    displayXY(latLng) {
      if (latLng) {
        return {
          lat: this.displayLat(latLng.lat, true),
          lng: this.displayLng(latLng.lng, true),
        };
      } else {
        return null;
      }
    },

    displayHK80(latLng) {
      if (latLng) {
        let hk80 = this.xyToHK80(latLng.lng, latLng.lat);
        return [this.displayHK80X(hk80[0], true), this.displayHK80Y(hk80[1], true)];
      } else {
        return null;
      }
    },

    xyToHK80(x, y) {
      return this.core.proj4(
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.WGS1984],
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.HK1980],
        [x, y]
      );
    },

    hk80ToXY(x, y) {
      return this.core.proj4(
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.HK1980],
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.WGS1984],
        [x, y]
      );
    },

    generateDynamicFieldSpecificType(fieldType, fieldNameIfEmpty, addColumnKey) {
      let result = this.dynamicFields.find((dynamicField) => {
        if (dynamicField.type == fieldType) {
          return dynamicField;
        }
      });

      // console.log(result);

      if (result) {
        // console.log(result.label, "", fieldType);
        return result.label;
      } else {
        result = this.dynamicFields.find((dynamicField) => {
          if (dynamicField.label == fieldNameIfEmpty) {
            return dynamicField;
          }
        });

        if (result) {
          let i = 1;
          while (true) {
            result = this.dynamicFields.find((dynamicField) => {
              if (dynamicField.label == fieldNameIfEmpty + "_" + i.toString()) {
                return dynamicField;
              }
            });

            if (!result) {
              fieldNameIfEmpty = fieldNameIfEmpty + "_" + i.toString();
              break;
            }

            i++;
          }
        }

        // this.addColumn(fieldNameIfEmpty, addColumnKey, fieldType);
        this.addColumn(fieldNameIfEmpty, fieldType);
        // console.log(fieldNameIfEmpty, "", fieldType);
        return fieldNameIfEmpty;
      }
    },

    addBlankRecord() {
      let me = this;

      let index = this.tableItems.length + 1;

      this.tableItems.push({
        index: index,
        leaflet_id: null,
        geojson: null,
      });

      this.showNewSnackBar(
        this.$t("common.insert") +
          " " +
          this.$t("common.record") +
          " " +
          this.$t("common.successfully")
      );

      // if (this.existingSpecialFieldTypes()) {
      //   this.tableItems.push({
      //     index: this.tableItems.length + 1,
      //     leaflet_id: null,
      //     geojson: null,
      //   });
      // } else {
      //   // console.log(this.enableShowInputSpecialTypeDialog)
      //   if (this.enableShowInputSpecialTypeDialog) {
      //     this.core.clearConfirmDialog();
      //     this.core.confirmDialogOK = () => {
      //       let nameZH = this.core.generateDynamicFieldSpecificType(
      //         GLOBAL.FIELD_TYPES.NAME_ZH,
      //         GLOBAL.FIELD_TYPES_NAME.NAME_ZH,
      //         "d"
      //       );

      //       let nameEN = this.core.generateDynamicFieldSpecificType(
      //         GLOBAL.FIELD_TYPES.NAME_EN,
      //         GLOBAL.FIELD_TYPES_NAME.NAME_EN,
      //         "c"
      //       );

      //       let addressZH = this.core.generateDynamicFieldSpecificType(
      //         GLOBAL.FIELD_TYPES.ADDRESS_ZH,
      //         GLOBAL.FIELD_TYPES_NAME.ADDRESS_ZH,
      //         "a"
      //       );

      //       let addressEN = this.core.generateDynamicFieldSpecificType(
      //         GLOBAL.FIELD_TYPES.ADDRESS_EN,
      //         GLOBAL.FIELD_TYPES_NAME.ADDRESS_EN,
      //         "b"
      //       );
      //       me.tableItems.push({
      //         index: me.tableItems.length + 1,
      //         leaflet_id: null,
      //         geojson: null,
      //       });

      //       this.goToLastTablePage();
      //     };
      //     this.core.confirmDialogMessage = this.$t(
      //       "common.confirmInputMessage"
      //     );
      //     this.core.confirmDialog = true;
      //   } else {
      //     let nameZH = this.core.generateDynamicFieldSpecificType(
      //       GLOBAL.FIELD_TYPES.NAME_ZH,
      //       GLOBAL.FIELD_TYPES_NAME.NAME_ZH,
      //       "d"
      //     );

      //     let nameEN = this.core.generateDynamicFieldSpecificType(
      //       GLOBAL.FIELD_TYPES.NAME_EN,
      //       GLOBAL.FIELD_TYPES_NAME.NAME_EN,
      //       "c"
      //     );

      //     let addressZH = this.core.generateDynamicFieldSpecificType(
      //       GLOBAL.FIELD_TYPES.ADDRESS_ZH,
      //       GLOBAL.FIELD_TYPES_NAME.ADDRESS_ZH,
      //       "a"
      //     );

      //     let addressEN = this.core.generateDynamicFieldSpecificType(
      //       GLOBAL.FIELD_TYPES.ADDRESS_EN,
      //       GLOBAL.FIELD_TYPES_NAME.ADDRESS_EN,
      //       "b"
      //     );

      //     me.tableItems.push({
      //       index: me.tableItems.length + 1,
      //       leaflet_id: null,
      //       geojson: null,
      //     });
      //   }
      // }
      // setTimeout(() => {
      let tableItem = this.tableItems.find((tableItem) => {
        if (tableItem.index == index) {
          return true;
        }
      });
      if (tableItem) {
        this.updateCurrentSelectedTableItem({ tableItem: tableItem });
        // this.currentSelectedTableItem = tableItem;
      }

      this.goToTableItemByIndex({ index: index });
      // }, 100);
    },

    goToTableItemByIndex({ index }) {
      let me = this;

      me.tableSortKey = null;

      // setTimeout(() => {
      this.$nextTick(() => {
        me.setShowTable({ val: true });
        me.currentPage = this.perPage ? Math.ceil(index / this.perPage) : 1;

        me.$nextTick(() => {
          // console.log(me)
          // setTimeout(() => {
          let row =
            me.table_container.$refs.table.$refs["item-rows"] ||
            me.table_container.$refs.table.$refs.itemRows;

          if (row) {
            for (let i = 0; i < row.length; i++) {
              if (row[i] && index == row[i].$el.getAttribute("aria-rowindex")) {
                setTimeout(() => {
                  // me.$nextTick(() => {
                  row[i].$el.scrollIntoView({
                    // behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                  });

                  let item = me.tableItems.find((item) => item.index == index);
                  if (item) {
                    me.zoomTo({ leaflet_id: item.leaflet_id });
                  }

                  // setTimeout(() => {
                  //   row[i].$el.scrollIntoView({
                  //     behavior: "smooth",
                  //     block: "end",
                  //     inline: "nearest",
                  //   });
                  // }, 100);
                  //fix the height
                  // if (i !== 9) {
                  //   console.log(i);
                  //   $(".b-table-sticky-header")[0].scrollTop -=
                  //     $("th[role='columnheader']").height() * 2;
                  // } else {
                  //   $(".b-table-sticky-header")[0].scrollTop +=
                  //     $("th[role='columnheader']").height() * 2;
                  // }
                  // });
                }, 100);
                break;
              }
            }
          }
        });
        // }, 100);
      });
      // }, 100);
    },

    async identify(latlng) {
      let me = this;
      this.$GA.identify_identify();

      let coord = proj4(
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.WGS1984],
        GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.HK1980],
        [latlng.lng, latlng.lat]
      );
      let scale = 591657550.5 / Math.pow(2, this.map.getZoom() - 1) / 2;

      this.showMapLoading();

      let res = await this.customFetch({
        url: GLOBAL.MAP_LAYER.URL.IDENTIFY + `/${coord[0]}/${coord[1]}/${scale}/WEB`,
        error_message: this.$t("common.errorIdentifyMessage"),
        error_callback: function () {
          me.closeMapLoading();
          me.$nextTick(() => {
            me.chgShowLeftBar(false);
          });
        },
        callback: function () {
          me.closeMapLoading();
        },
      });

      // console.log(res);
      return res;
    },

    //isUp = true or false
    chgindexOverLay(i, _isUp) {
      let isUp = _isUp || false;

      if (isUp) {
        if (i == 0) {
          return;
        }
      } else {
        if (i == this.dynamicLayers.length - 1) {
          return;
        }
      }

      let dynamicLayer = this.dynamicLayers.splice(i, 1);
      if (isUp) {
        this.dynamicLayers.splice(i - 1, 0, dynamicLayer[0]);
      } else {
        this.dynamicLayers.splice(i + 1, 0, dynamicLayer[0]);
      }

      for (let j = 0; j < this.dynamicLayers.length; j++) {
        let dL = this.dynamicLayers[j];
        let layer = this.dynamicLayerDrawnItems.getLayer[dL.leaflet_id];
        if (layer) {
          layer.setZIndex(this.indexOverLay + this.dynamicLayers.length - j);
        }
      }
    },

    async switchOverlay(id, e) {
      let me = this,
        layer = null,
        refLayer = null,
        dynamicLayer = this.dynamicLayers.find(
          (item) => item.id.toString() == id.toString()
        );

      //this is for default layers only
      if (e) {
        switch (id.toString()) {
          case GLOBAL.MAP_LAYER.NAME.LOT_LAYER:
            layer = this.lotLayer;
            // this.dynamicLayerDrawnItems.addLayer(layer);
            break;

          case GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER:
            layer = this.buildingLayer;
            // this.dynamicLayerDrawnItems.addLayer(layer);
            break;

          case GLOBAL.MAP_LAYER.NAME.TABLE_LAYER:
            // layer = this.drawnItems.addTo(this.map);
            // this.tableItemsRefLayerDrawnItems.addTo(this.map);
            break;
        }

        if (layer) {
          return;
        }
      } else {
        switch (id.toString()) {
          case GLOBAL.MAP_LAYER.NAME.LOT_LAYER:
            layer = this.lotLayer;
            // this.dynamicLayerDrawnItems.removeLayer(layer);
            break;
          case GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER:
            layer = this.buildingLayer;
            // this.dynamicLayerDrawnItems.removeLayer(layer);
            break;
          case GLOBAL.MAP_LAYER.NAME.TABLE_LAYER:
            layer = this.drawnItems;
            // this.map.removeLayer(layer);
            // refLayer = this.tableItemsRefLayerDrawnItems;
            // this.map.removeLayer(refLayer);
            break;
        }

        if (refLayer || layer) {
          return;
        }
      }

      //this is for user layers only
      try {
        if (e) {
          // console.log(dynamicLayer);

          let layer = null,
            res = null,
            tmpUrl = null;

          if (dynamicLayer.type == GLOBAL.LAYER_TYPE_FORMAT.WFS) {
            var parameters = L.Util.extend({
              service: "WFS",
              version: "1.0.0",
              request: "GetFeature",
              outputFormat: "application/json",
              format_options: "callback: getJson",
              srsName: "EPSG:4326",
            });

            tmpUrl =
              dynamicLayer.url +
              L.Util.getParamString(parameters) +
              "&bbox=" +
              this.map.getBounds().toBBoxString() +
              ",EPSG:4326" +
              `&${dynamicLayer.params}`;
          } else {
            tmpUrl = dynamicLayer.url;
          }

          if (dynamicLayer.type !== GLOBAL.LAYER_TYPE_FORMAT.WMS) {
            res = await this.customFetch({
              url: tmpUrl,
              error_message: this.$t("common.connectLayerNetworkMessage"),
            });
            if (!res) {
              return;
            }
          }

          switch (dynamicLayer.type) {
            case GLOBAL.LAYER_TYPE_FORMAT.ARCGIS:
              layer = new L.FeatureGroup();

              layer.addLayer(
                L.esri.dynamicMapLayer({
                  url: tmpUrl,
                  opacity: 0.85,
                  useCors: true,
                })
              );

              layer.addLayer(
                L.esri.featureLayer({
                  url: tmpUrl,
                  where: dynamicLayer.where,
                  opacity: 0.85,
                  useCors: true,
                })
              );

              layer.addLayer(
                L.esri.imageMapLayer({
                  url: tmpUrl,
                  opacity: 0.85,
                  useCors: false,
                })
              );

              layer.addLayer(
                L.esri.tiledMapLayer({
                  url: tmpUrl,
                  opacity: 0.85,
                  useCors: false,
                })
              );

              break;

            case GLOBAL.LAYER_TYPE_FORMAT.WMS:
              // console.log("WMS START");
              layer = L.tileLayer.wms(tmpUrl, {
                layers: dynamicLayer.layers,
                // srs: GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.WGS1984],
                // crs: GLOBAL.CRS_TO_EPSG[GLOBAL.IMPORT.CRS_OPTIONS.WGS1984],
                format: "image/png",
                transparent: true,
              });

              break;
            case GLOBAL.LAYER_TYPE_FORMAT.WFS:
              // console.log("WFS START");
              layer = L.geoJSON(res);
              break;

            case GLOBAL.LAYER_TYPE_FORMAT.GEOJSON:
              // console.log("GEOJSON START");
              layer = L.geoJSON(res);
              break;
            case GLOBAL.LAYER_TYPE_FORMAT.CSV:
              // console.log("CSV START");
              let options = {
                latfield: dynamicLayer.options.latitudeField,
                lonfield: dynamicLayer.options.longitudeField,
                delimiter: ",",
              };

              layer = omnivore.csv.parse(res, options);

              break;
            case GLOBAL.LAYER_TYPE_FORMAT.KML:
              // console.log("KML START");
              layer = omnivore.kml.parse(res);
              break;
            case GLOBAL.LAYER_TYPE_FORMAT.GML:
              // console.log("GML START");
              let gmlFeatures = this.import.loadGML(res);

              let geoJSON = JSON.parse(
                new ol.format.GeoJSON().writeFeatures(gmlFeatures)
              );

              layer = L.geoJSON(geoJSON);
              break;
            default:
              // console.log(dynamicLayer.type, GLOBAL.LAYER_TYPE_FORMAT.ARCGIS)
              console.log("Not Support Layer Type");
          }

          if (
            dynamicLayer.type == GLOBAL.LAYER_TYPE_FORMAT.WMS ||
            dynamicLayer.type == GLOBAL.LAYER_TYPE_FORMAT.ARCGIS
          ) {
            this.dynamicLayerDrawnItems.addLayer(layer);
            dynamicLayer.leaflet_id = layer._leaflet_id;
          } else if (layer && layer.toGeoJSON && typeof layer.toGeoJSON == "function") {
            layer = me.$refs.import.createCRSLayer(
              layer.toGeoJSON(),
              dynamicLayer.options.crsOption,
              dynamicLayer.style
            );

            this.dynamicLayerDrawnItems.addLayer(layer);
            dynamicLayer.leaflet_id = layer._leaflet_id;

            // console.log(layer);
          } else {
            this.showNewSnackBar(
              this.$t("common.connectLayerFailedMessage") + ": " + dynamicLayer.title
            );
          }
        } else {
          this.dynamicLayerDrawnItems.removeLayer(dynamicLayer.leaflet_id);
        }
      } catch (e) {
        console.log(e);
      }
    },

    showConfirmDialogForSwitchLayers(dynamicLayerTitle) {
      this.clearConfirmDialog();
      this.confirmDialogMessage = this.$t("common.confirmToDeleteLayerMessage");
      this.confirmDialogOK = () => {
        for (let i = 0; i < this.dynamicLayers.length; i++) {
          let dynamicLayer = this.dynamicLayers[i];
          if (dynamicLayer.title == dynamicLayerTitle) {
            this.dynamicLayerDrawnItems.removeLayer(dynamicLayer.leaflet_id);
            this.dynamicLayers.splice(i, 1);
            break;
          }
        }
      };
      this.confirmDialog = true;
    },

    addLayer(
      addLayerType,
      addLayerLayerName,
      addLayerUrl,
      addLayerParams,
      addLayerLayers,
      addLayerWhere,
      options,
      style
    ) {
      this.dynamicLayers.push({
        type: addLayerType,
        title: addLayerLayerName,
        url: addLayerUrl,
        id: Date.now(),
        params: addLayerParams,
        layers: addLayerLayers,
        where: addLayerWhere,
        options: options,
        style: style,
      });
    },

    editLayer(
      id,
      addLayerType,
      addLayerLayerName,
      addLayerUrl,
      addLayerParams,
      addLayerLayers,
      addLayerWhere,
      options,
      style
    ) {
      for (let i = 0; i < this.dynamicLayers.length; i++) {
        let dynamicLayer = this.dynamicLayers[i];
        if (dynamicLayer.id.toString() === id.toString()) {
          dynamicLayer.type = addLayerType;
          dynamicLayer.title = addLayerLayerName;
          dynamicLayer.url = addLayerUrl;
          dynamicLayer.params = addLayerParams;
          dynamicLayer.layers = addLayerLayers;
          dynamicLayer.where = addLayerWhere;
          dynamicLayer.options = options;
          dynamicLayer.style = style;
          break;
        }
      }
      this.saveDataToLocalStorage();
    },

    deleteAllLayers() {
      this.confirmDialogPersistent = false;
      this.confirmDialogOK = (e) => {
        for (let i = 0; i < this.dynamicLayers.length; i++) {
          let dynamicLayer = this.dynamicLayers[i];
          if (dynamicLayer.leaflet_id) {
            this.dynamicLayerDrawnItems.removeLayer(dynamicLayer.leaflet_id);
          }
        }

        this.dynamicLayers = [];
      };
      this.confirmDialogMessage = this.$t("common.confirmDeleteAllLayersMessage");
      this.confirmDialog = true;
    },

    clearConfirmDialog() {
      this.confirmDialog = false;
      this.confirmDialogPersistent = false;
      this.confirmDialogOK = null;
      this.confirmDialogCustom = null;
      this.confirmDialogCustomTitle = "";
      this.confirmDialogMessage = "";
      this.confirmDialogTitle = "";
      this.confirmDialogWarningTitleIcon = false;
    },

    updateTableLayerProperties(newProperties, leaflet_id) {
      // console.log(newProperties, leaflet_id, this.drawnItems)
      this.drawnItems.getLayer(leaflet_id).feature.properties = newProperties;
    },

    _setValueFromItems(item, field, value) {
      // console.log("_setValueFromItems");
      // console.log(item, field, value);
      // console.log(item);
      if (item.leaflet_id) {
        // if (item.geojson && item.geojson.hasOwnProperty("properties")) {
        if (!item.geojson.properties) {
          item.geojson.properties = {};
        }

        item.geojson.properties[field.label] = value;
        this.updateTableLayerProperties(item.geojson.properties, item.leaflet_id);
      } else {
        //for empty case
        if (!item.item) {
          item.item = {};
        }
        item.item[field.label] = value;
      }

      this.$forceUpdate();
      this.saveDataToLocalStorage();
    },

    _getValueFromItems(item, field) {
      if (
        item.geojson &&
        item.geojson.properties &&
        item.geojson.properties.hasOwnProperty(field.label)
      ) {
        if (typeof item.geojson.properties[field.label] === "string") {
          return item.geojson.properties[field.label];
        } else {
          return JSON.stringify(item.geojson.properties[field.label]);
        }
      } else if (item.item && item.item.hasOwnProperty(field.label)) {
        return item.item[field.label];
      }

      return null;
    },

    verifyConvertNumber(val) {
      if (val === "") {
        return true;
      } else if (Number(val)) {
        return true;
      } else {
        return false;
      }
    },

    verifyConvertDate(val) {
      if (val === "") {
        return true;
      } else if (val.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/) && Date.parse(val)) {
        return true;
      } else {
        return false;
      }
    },

    show_change_type_dialog(dynamicField, type) {
      this.clearConfirmDialog();

      let orgType = dynamicField.type || GLOBAL.FIELD_TYPES.TEXT;

      if (orgType === type) {
        return;
      }

      this.confirmDialogOK = (e) => {
        let errorIndex = [];
        let errorItems = [];
        for (let i = 0; i < this.tableItems.length; i++) {
          let item = this.tableItems[i];
          let value = this._getValueFromItems(item, dynamicField);

          if (!value) {
            continue;
            //single text or multi text -> number or date
          } else if (
            (type == GLOBAL.FIELD_TYPES.NUMBER && !this.verifyConvertNumber(value)) ||
            (type == GLOBAL.FIELD_TYPES.DATE && !this.verifyConvertDate(value))
          ) {
            errorIndex.push(item.index);
            errorItems.push(item);
          }
        }

        if (errorIndex.length > 0) {
          let me = this;
          // setTimeout(() => {
          this.$nextTick(() => {
            me.clearConfirmDialog();
            me.confirmDialogPersistent = true;
            me.confirmDialogOK = () => {};
            me.confirmDialogCustom = () => {
              for (let i = 0; i < errorItems.length; i++) {
                me._setValueFromItems(errorItems[i], dynamicField, "");
                // console.log(errorItems[i], dynamicField.label);
                // errorItems[i][dynamicField.label] = "";
              }

              dynamicField.type = type;
              me.saveDataToLocalStorage();
            };
            me.confirmDialogCustomTitle = me.$t("common.clearConvertDataFailed");
            me.confirmDialogMessage =
              this.$t("common.convertDataFailedMessage") +
              errorIndex.join(", ") +
              me.$t("common.clearConvertDataFailedMessage");
            me.confirmDialog = true;
          });
          // }, 100);
        } else {
          dynamicField.type = type;
          this.saveDataToLocalStorage();
        }
      };
      this.confirmDialogPersistent = false;
      this.confirmDialogMessage = this.$t("common.confirmToChangeTypeMessage");
      this.confirmDialog = true;
    },

    extentDrawnItemBounds() {
      this.$GA.t_click_extent();

      let bounds = null,
        me = this;

      if (this.drawnItems.getLayers().length > 0) {
        bounds = this.drawnItems.getBounds();
      }

      if (this.tableItemsRefLayerDrawnItems.getLayers().length > 0) {
        let tmpBounds = this.tableItemsRefLayerDrawnItems.getBounds();
        if (bounds) {
          bounds.extend(tmpBounds);
        } else {
          bounds = tmpBounds;
        }
      }

      if (bounds) {
        me.map.fitBounds(bounds);
      }
    },

    leftBarUpdateSelectMarker(val) {
      let tmpLayer = null;

      //first check for table item
      //change back previous marker to orginial icon
      tmpLayer = this.drawnItems.getLayer(this.currentSelectedSearchResultLeafletId);
      if (tmpLayer) {
        tmpLayer.setIcon(L.icon(GLOBAL.LEAFLET.BLUE_ICON));
      }

      //second check for search result
      //skip change if there is same leaflet_id
      if (val == this.currentSelectedSearchResultLeafletId) {
        return;
      }

      //old
      tmpLayer = this.searchResultDrawnItems.getLayer(
        this.currentSelectedSearchResultLeafletId
      );
      if (tmpLayer) {
        // console.log(tmpLayer);
        tmpLayer.setIcon(L.icon(GLOBAL.LEAFLET.GREEN_SEARCH_ICON));
        tmpLayer._resetZIndex();
      }

      //new
      tmpLayer = this.map._layers[val];
      if (tmpLayer) {
        // this.chgShowLeftBar(true);
        // tmpLayer.setIcon(L.icon(GLOBAL.LEAFLET.GOLD_ICON));
        tmpLayer.setIcon(L.icon(GLOBAL.LEAFLET.RED_SEARCH_ICON));
        tmpLayer._bringToFront();
      }

      this.currentSelectedSearchResultLeafletId = val;
    },

    //SearchResult Methods
    chgShowLeftBar(val) {
      this.showLeftBar = val;
    },

    //Other Methods
    //
    checkLocalforageSupport() {
      if (
        localforage.supports(localforage.WEBSQL) ||
        localforage.supports(localforage.INDEXEDDB) ||
        localforage.supports(localforage.LOCALSTORAGE)
      ) {
        return true;
      } else {
        return false;
      }
    },

    renderAttribution() {
      // console.log("renderAttribution");
      $(".customAttribution").html(
        // '<img class="attribution_logo" src="./img/favicon.ico" /> | ' +
        this.$t("common.copyrightString")
      );
    },
    detectIEBrowser() {
      // const result = browser();

      // console.log(result);

      let ua = window.navigator.userAgent;
      //ie 10 or older
      let msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }
      //ie 11
      if (ua.indexOf("Trident/") > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      return "";
    },

    mySortCompare(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
      if (key === GLOBAL.HIDDEN_FIELD_LABELS.INDEX) {
        return aRow.index > bRow.index;
      }

      for (let dynamicFieldIndex in this.dynamicFields) {
        let item = this.dynamicFields[dynamicFieldIndex];
        if (item.key == key) {
          let a = "";
          let b = "";

          if (
            aRow.geojson &&
            aRow.geojson.properties &&
            aRow.geojson.properties[item.label]
          ) {
            a = aRow.geojson.properties[item.label];
          } else if (aRow.item && aRow.item[item.label]) {
            a = aRow.item[item.label];
          } else {
            // console.log(aRow, item.label);
          }

          if (
            bRow.geojson &&
            bRow.geojson.properties &&
            bRow.geojson.properties[item.label]
          ) {
            b = bRow.geojson.properties[item.label];
          } else if (bRow.item && bRow.item[item.label]) {
            b = bRow.item[item.label];
          } else {
            // console.log(bRow, item.label);
          }

          // empty case
          if (a == "" || b == "") {
            if (sortDesc) {
              return a < b ? -1 : a > b ? 1 : 0;
            } else {
              return a < b ? 1 : a > b ? -1 : 0;
            }
          }

          return a < b ? -1 : a > b ? 1 : 0;
        }
      }

      return false;
    },

    zoomTo({ leaflet_id, ref_leaflet_id, zoomIn }) {
      // console.log({ leaflet_id, ref_leaflet_id, zoomIn });
      let map = this.map,
        bounds = null;

      if (leaflet_id) {
        // console.log(leaflet_id, this.drawnItems);
        // let drawnItem = this.drawnItems.getLayer(leaflet_id);
        // if (drawnItem) {
        //   //if polygon
        //   // console.log(drawnItem);
        //   if (drawnItem.getLatLng) {
        //     bounds = new L.LatLngBounds([drawnItem.getLatLng()]);
        //   } else if (drawnItem.getBounds) {
        //     bounds = drawnItem.getBounds();
        //   }
        // }
        let layer = this.map._layers[leaflet_id];
        if (layer) {
          //if polygon
          // console.log(drawnItem);
          // console.log(layer);
          if (layer.getLatLng) {
            bounds = new L.LatLngBounds([layer.getLatLng()]);
          } else if (layer.getLayers && layer.getLayers().length > 0) {
            bounds = layer.getBounds();
          }
        }
      }

      if (ref_leaflet_id) {
        // console.log(ref_leaflet_id, this.tableItemsRefLayerDrawnItems)

        let tableItemsRefLayerDrawnItem = this.tableItemsRefLayerDrawnItems.getLayer(
          ref_leaflet_id
        );

        if (tableItemsRefLayerDrawnItem) {
          if (bounds) {
            bounds.extend(tableItemsRefLayerDrawnItem.getBounds());
          } else {
            bounds = tableItemsRefLayerDrawnItem.getBounds();
          }
        }
      }

      if (bounds) {
        if (zoomIn) {
          this.map.fitBounds(bounds);
        } else {
          this.map.fitBounds(bounds, { maxZoom: this.map.getZoom() });
        }
      }
    },

    isExistingDynamicField(label, caseSensitive = true) {
      let result = false;
      for (let dynamicFieldindex in this.dynamicFields) {
        if (caseSensitive) {
          if (this.dynamicFields[dynamicFieldindex]["label"] == label) {
            result = true;
            break;
          }
        } else {
          if (
            this.dynamicFields[dynamicFieldindex]["label"] &&
            this.dynamicFields[dynamicFieldindex]["label"].toString().toLowerCase() ==
              label.toString().toLowerCase()
          ) {
            result = true;
            break;
          }
        }
      }
      return result;
    },

    //Check label Whether not at hiddenFieldLabelsArray
    isNotHiddenField(label) {
      let display = true;
      for (let hiddenFieldIndex in this.GLOBAL.HIDDEN_FIELD_LABELS) {
        if (
          this.GLOBAL.HIDDEN_FIELD_LABELS[hiddenFieldIndex] &&
          this.GLOBAL.HIDDEN_FIELD_LABELS[hiddenFieldIndex].toLowerCase() ==
            label.toLowerCase()
        ) {
          display = false;
          break;
        }
      }
      return display;
    },

    onDropFile(event) {
      event.preventDefault();
      // console.log(event.dataTransfer.files);
      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        this.$refs["import"].show_import_modal(event.dataTransfer.files);
      }
    },

    updateDynamicFieldItem(dynamicField, value) {
      if (!this.isExistingDynamicField(value)) {
        for (let i = 0; i < this.dynamicFields.length; i++) {
          if (this.dynamicFields[i].key == dynamicField.key) {
            for (let j = 0; j < this.tableItems.length; j++) {
              // this.tableItems.forEach((item) => {
              let item = this.tableItems[j];
              let properties = null;
              try {
                properties = item.geojson.properties;
              } catch (e) {
                try {
                  properties = item.item;
                } catch (e) {
                  // throw "Update Dynamic Field Item Failed: " + e;
                }
              }
              // });

              if (
                properties != null &&
                properties.hasOwnProperty(this.dynamicFields[i].label)
              ) {
                properties[value] = properties[this.dynamicFields[i].label];
                delete properties[this.dynamicFields[i].label];
              }
            }

            this.dynamicFields[i].label = value;
            // this.$refs["editfield"].updateDynamicFieldSuccess()
            this.saveDataToLocalStorage();
            return true;
          }
        }
      }

      return false;
    },

    updateDynamicFieldItemIndex(item, index, action) {
      // console.log(item, index, action);
      let spliceItem = this.dynamicFields.splice(index, 1)[0];
      let affectIndex = 0;
      if (action == "up") {
        if (index == 0) {
          affectIndex = index;
        } else {
          affectIndex = index - 1;
        }
      } else if (action == "down") {
        affectIndex = index + 1;
      }

      //sort for fields list only
      this.dynamicFields.splice(affectIndex, 0, spliceItem);
    },

    onDynamicFieldDrop(event, item, index) {
      let drap_item_index = event.dataTransfer.getData("item_index");
      if (drap_item_index != index) {
        let spliceItem = this.dynamicFields.splice(drap_item_index, 1)[0];
        this.dynamicFields.splice(index, 0, spliceItem);
      }
    },

    startDynamicFieldDrag(event, index) {
      event.dataTransfer.setData("item_index", index);
    },

    //New Column functions
    resetModalState() {
      this.newColumnNameState = null;
    },

    resetModalInput() {
      this.newColumnName = null;
    },

    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.addColumnByModal(this.newColumnName);
    },

    changeBasemap(mapBasemapName) {
      this.map.removeLayer(this.topoLayer);
      this.map.removeLayer(this.orthoLayer);

      switch (mapBasemapName) {
        case GLOBAL.MAP_BASEMAP_NAME.TOPO:
          this.map.addLayer(this.topoLayer);
          break;
        case GLOBAL.MAP_BASEMAP_NAME.ORTHO:
          this.map.addLayer(this.orthoLayer);
          break;
      }
    },

    async customFetch({ url, error_message, error_callback, callback }) {
      let me = this;

      try {
        // let headers = {
        //   "X-Requested-With": "XMLHttpRequest",
        // };
        if (process.env.NODE_ENV == "development") {
        // if (process.env.NODE_ENV == "development" && !url.startsWith("http")) {
          // headers["Target-Endpoint"] = process.env.VUE_APP_MAP_GOV_DOMAIN + url;
          url = process.env.VUE_APP_PROXY_SERVER +"/" + url;
        }

        let res = await $.ajax({
          // url: "https://thingproxy.freeboard.io/fetch/" + url,
          // url: url,
          url: url,
          // crossDomain: true,
          // dataType: "json",
          // contentType: "application/json;charset=UTF-8",
          // headers: headers,
          // dataType: "jsonp",
          // url: "http://172.18.8.113:3000/",
          // headers: {
          //   "Target-Endpoint": url,
          // },
          // crossDomain: true,
          // headers: {
          //   "Access-Control-Allow-Origin": "*",
          // },
          timeout: 60000,
          success: function (event) {
            // console.log("success:", event)
            if (typeof event == "object") {
              if (callback) {
                callback(event);
              }
            } else {
              // console.log("error 1", url)
              if (error_message) {
                me.showNewSnackBar(error_message);
              }
              if (error_callback) {
                error_callback();
              }
            }
          },
          error: function (event) {
            throw ("Fetch Failed", event);
            // console.log("error 2", url)
            // console.log("error:", event)
            // if (error_message) {
            //   me.showNewSnackBar(error_message);
            // }
            // if (error_callback) {
            //   error_callback();
            // }
          },
        });

        return res;
      } catch (e) {
        if (error_message) {
          me.showNewSnackBar(error_message);
        }
        if (error_callback) {
          error_callback(e);
        }
      }
    },

    init() {
      //openlayer for convert
      this.olMap = new Map({
        target: "olMap",
        layers: [],
        view: new View({
          //projection: 'EPSG:3857',
          projection: GLOBAL.CRS_TO_EPSG.WGS1984,
          //projection: 'EPSG:3857',
          center: [0, 0],
          zoom: 2,
        }),
      });

      this.updateWebTitle();

      //add topoLayer
      this.topoLayer = L.tileLayer(GLOBAL.MAP_LAYER.URL.TOPO, {
        id: "topo",
        KEY: GLOBAL.MAP_KEY,
        maxZoom: 20,
      });

      //add orthoLayer
      this.orthoLayer = L.tileLayer(GLOBAL.MAP_LAYER.URL.ORTHO, {
        id: "ortho",
        KEY: GLOBAL.MAP_KEY,
        maxZoom: 20,
      });

      this.map = L.map("map", {
        renderer: L.canvas(),
        preferCanvas: true,
        boxZoom: true,
        zoomControl: false,
        // maxZoom: 18,
        minZoom: this.minZoom - 1,
        maxBounds: this.maxBounds,
        attributionControl: false,
        condensedAttributionControl: false,
        layers: [this.topoLayer],
        tap: false,
      }).setView(this.mapDefaultExtent, this.minZoom);

      // console.log(this.map)

      //add lot layer
      // this.lotLayer = L.esri.dynamicMapLayer({
      this.lotLayer = L.esri.dynamicMapLayer(
        this.$refs.import.presetLayerOptionsBuilder({
          id: GLOBAL.MAP_LAYER.NAME.LOT_LAYER,
          url: GLOBAL.MAP_LAYER.URL.LOT_LAYER,
          dynamicLayers: [
            {
              id: 1,
              source: { type: "mapLayer", mapLayerId: 1 },
              ...this.$refs.import.createEsriDrawingInfo(),
            },
          ],
          outputType: "image",
        })
      );

      this.lotLayerQuery = L.esri.query({
        url: GLOBAL.MAP_LAYER.URL.LOT_LAYER_QUERY,
      });

      this.lotLayerQuery.params["key"] = GLOBAL.MAP_KEY;

      //add building layer
      this.buildingLayer = L.esri.dynamicMapLayer(
        this.$refs.import.presetLayerOptionsBuilder({
          id: GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER,
          url: GLOBAL.MAP_LAYER.URL.BUILDING_LAYER,
          dynamicLayers: [
            {
              id: 0,
              source: { type: "mapLayer", mapLayerId: 0 },
              ...this.$refs.import.createEsriDrawingInfo(),
            },
          ],
          // layerDefs: { 0: "1=1" },
          outputType: "image",
        })
      );

      this.buildingLayerQuery = L.esri.query({
        url: GLOBAL.MAP_LAYER.URL.BUILDING_LAYER_QUERY,
      });

      this.buildingLayerQuery.params["key"] = GLOBAL.MAP_KEY;

      let i = 0;

      //add feature groups to map
      this.identifyResultDrawnItems = new L.FeatureGroup();
      this.identifyResultDrawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.identifyResultDrawnItems);

      this.identifyMainDrawnItems = new L.FeatureGroup();
      this.identifyMainDrawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.identifyMainDrawnItems);

      this.searchResultDrawnItems = new L.FeatureGroup();
      this.searchResultDrawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.searchResultDrawnItems);

      this.drawnItems = new L.FeatureGroup();
      this.drawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.drawnItems);

      this.tableItemsRefLayerDrawnItems = new L.FeatureGroup();
      this.tableItemsRefLayerDrawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.tableItemsRefLayerDrawnItems);

      this.dynamicLayerDrawnItems = new L.FeatureGroup();
      this.dynamicLayerDrawnItems.setZIndex(this.indexDrawnItem + i++);
      this.map.addLayer(this.dynamicLayerDrawnItems);

      this.renderlabelBaseMap();
      this.attachMapListener();
    },

    attachMapListener() {
      let me = this,
        leftBar = this.$refs.leftBar,
        _dblClickTimer = null;

      //add listener for identify
      this.map
        .on("click tap", function (e) {
          //stop double case
          if (_dblClickTimer !== null) {
            clearTimeout(_dblClickTimer);
            return;
          }
          _dblClickTimer = setTimeout(async () => {
            // real 'click' event handler here
            _dblClickTimer = null;

            if (me.enableIdentify) {
              //clear layers first
              me.identifyMainDrawnItems.clearLayers();
              me.identifyResultDrawnItems.clearLayers();
              let result = await me.identify(e.latlng);

              if (typeof result == "object") {
                leftBar.identifyXY = e.latlng;
                leftBar.identifyResult = result;
              } else {
                leftBar.identifyXY = null;
                leftBar.identifyResult = null;
              }
            }

            if (me.enableIdentifyTableItemSubLayer) {
              // let layers = me.dynamicLayerDrawnItems.getLayers();

              // if (layers.length == 0) {
              //   return;
              // }

              //lot layer query
              if (
                me.currentSelectedTableItem &&
                leftBar.$refs.leftBarLayers.presetLayerSelected ==
                  GLOBAL.MAP_LAYER.NAME.LOT_LAYER
                // me.$refs.switchLayers.presetLayerSelected == GLOBAL.MAP_LAYER.NAME.LOT_LAYER
              ) {
                // console.log(e.latlng);
                me.queryLotLayer({
                  latlng: e.latlng,
                  tableItem: me.currentSelectedTableItem,
                });
              }

              //building layer query
              if (
                me.currentSelectedTableItem &&
                leftBar.$refs.leftBarLayers.presetLayerSelected ==
                  GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER
              ) {
                // console.log(e.latlng);
                me.queryBuildingLayer({
                  latlng: e.latlng,
                  tableItem: me.currentSelectedTableItem,
                });
              }
            }
          }, 500);
        })
        .on("dblclick", function () {
          clearTimeout(_dblClickTimer);
          _dblClickTimer = null;

          // real 'dblclick' handler here (if any). Do not add anything to just have the default zoom behavior
        });

      this.map.on("locationfound", (e) => {
        me.$GA.l_location_found();
      });

      this.map.on("locationerror", (e) => {
        me.$GA.l_location_error();
      });

      this.map.on("zoomstart", function (e) {});

      this.map.on("zoomend", function (e) {
        //run checkinzoom checking
        // let leftBarLayers = me.$refs.leftBar.$refs.leftBarLayers;
        // if (leftBarLayers) {
        //   leftBarLayers.checkLayerInZoom();
        // }
      });

      this.map.on("moveend", function (e) {
        //add refresh layer  function
        if (!leftBar.$refs.leftBarLayers) {
          return;
        }

        leftBar.$refs.leftBarLayers.dynamicLayersSelected.find((dynamicLayerSelected) => {
          me.dynamicLayers.find((dynamicLayer) => {
            if (
              dynamicLayer.id === dynamicLayerSelected &&
              dynamicLayer.type == GLOBAL.LAYER_TYPE_FORMAT.WFS &&
              dynamicLayer.leaflet_id &&
              dynamicLayer.leaflet_id != ""
            ) {
              me.switchOverlay(dynamicLayer.id, false);
              me.switchOverlay(dynamicLayer.id, true);
              return;
            }
          });
        });
      });

      this.map.on(L.Draw.Event.CREATED, function (e) {
        me.$GA.added_marker_by_drawing();

        let type = e.layerType,
          layer = e.layer;

        // if (type === LAYER_TYPE.CIRCLE) {
        // } else if (type === LAYER_TYPE.MARKER) {
        // }

        me.drawnItems.removeLayer(layer);

        layer = L.geoJson(layer.toGeoJSON()).getLayers()[0];
        // layer.on("click", function (e) {
        //   me.leftBarUpdateSelectMarker(layer._leaflet_id);
        // });

        me.attachDrawnMarkerToMap(layer, type);

        if (me.enableIdentifyTableItemMarker && me.currentSelectedTableItem) {
          if (me.currentSelectedTableItem.leaflet_id) {
            me.drawnItems.removeLayer(me.currentSelectedTableItem.leaflet_id);
          }

          // let tmpCurrentSelectedTableItem = me.currentSelectedTableItem;
          // me.updateCurrentSelectedTableItem(null);
          // me.updateCurrentSelectedTableItem(tmpCurrentSelectedTableItem);
          // me.currentSelectedTableItem = null;
          // me.currentSelectedTableItem = tmpCurrentSelectedTableItem;

          me.updateCurrentSelectedTableItem({
            tableItem: me.currentSelectedTableItem,
            forceUpdate: true,
          });

          me.goToTableItemByIndex({
            index: me.addItemToTableData(layer, type, true).index,
          });

          me.showNewSnackBar(
            me.$t("common.insert") +
              " " +
              me.$t("common.marker") +
              " " +
              me.$t("common.successfully")
          );
        } else {
          me.goToTableItemByIndex({
            index: me.addItemToTableData(layer, type, false).index,
          });
        }

        me.saveDataToLocalStorage();
        return false;
      });

      this.map.on(L.Draw.Event.EDITED, function (e) {
        me.confirmDialogOK = () => {
          me.$GA.edited_marker_by_drawing();

          var layers = e.layers;

          layers.eachLayer(function (layer) {
            me.updateTableItemGeoJSON(layer);
          });

          me.showNewSnackBar(
            me.$t("common.edit") +
              " " +
              me.$t("common.record") +
              " " +
              me.$t("common.successfully")
          );

          me.$forceUpdate();
          me.saveDataToLocalStorage();
        };
        me.confirmDialogCancel = () => {
          me.reloadTableItemsAndLayers();
          me.saveDataToLocalStorage();
        };
        me.confirmDialogMessage = me.$t(
          "common.editMarkerTools.editMarkersConfirmMessage"
        );
        me.confirmDialog = true;
      });

      this.map.on(L.Draw.Event.DELETED, function (e) {
        me.confirmDialogOK = () => {
          me.$GA.deleted_marker_by_drawing();

          let tempCurrentSelectTableItem = me.currentSelectedTableItem;

          let layers = e.layers;
          layers.eachLayer(function (layer) {
            me.removeTableItemByLeafletId(layer._leaflet_id);
          });

          me.updateCurrentSelectedTableItem({
            tableItem: tempCurrentSelectTableItem,
          });

          me.saveDataToLocalStorage();
          me.$forceUpdate();
        };
        me.confirmDialogCancel = () => {
          me.reloadTableItemsAndLayers();
          // me.saveDataToLocalStorage();
        };
        me.confirmDialogMessage = me.$t(
          "common.editMarkerTools.removeMarkersConfirmMessage"
        );
        me.confirmDialog = true;
      });

      this.map.on(L.Draw.Event.EDITSTART, (e) => {
        me.enableIdentify = false;
      });

      this.map.on(L.Draw.Event.DELETESTART, (e) => {
        me.enableIdentify = false;
      });

      this.map.on(L.Draw.Event.DRAWSTART, (e) => {
        me.enableIdentify = false;
      });

      this.map.on(L.Draw.Event.EDITSTOP, (e) => {
        me.enableIdentify = true;
      });

      this.map.on(L.Draw.Event.DELETESTOP, (e) => {
        me.enableIdentify = true;
      });

      this.map.on(L.Draw.Event.DRAWSTOP, (e) => {
        me.enableIdentify = true;
      });

      //print listener
      this.map.on(L.Control.BrowserPrint.Event.PrintEnd, (e) => {
        me.enablePrintCustom = false;
      });
    },

    unattachRefLayerData_confirmedByTableItem({ tableItem }) {
      // console.log("unattachRefLayerData_confirmed", tableItem);
      if (tableItem.hasOwnProperty("refLayer")) {
        this.tableItemsRefLayerDrawnItems.removeLayer(tableItem.refLayer.leaflet_id);
        delete tableItem["refLayer"];
      }

      this.saveDataToLocalStorage();
    },

    unattachRefLayerData_confirmed() {
      if (this.currentSelectedTableItem.hasOwnProperty("refLayer")) {
        this.tableItemsRefLayerDrawnItems.removeLayer(
          this.currentSelectedTableItem.refLayer.leaflet_id
        );
        delete this.currentSelectedTableItem["refLayer"];
      }

      this.saveDataToLocalStorage();
    },

    unattachRefLayerData() {
      // this.confirmDialogPersistent = true;
      this.confirmDialogOK = this.unattachRefLayerData_confirmed;
      this.confirmDialogMessage = this.$t("common.confirmToDeleteLayerMessage");
      this.confirmDialog = true;
    },

    attachRefLayerData({ features, latlng, layerName, tableItem }) {
      this.unattachRefLayerData_confirmedByTableItem({ tableItem: tableItem });
      // console.log(features);
      let refLayer = L.geoJSON(features, {
        ...this.$refs.import.attachOrginalLayerOptions(),
      });

      this.tableItemsRefLayerDrawnItems.addLayer(
        // this.$refs.import.attachOrginalLayerListener(layer)
        refLayer
      );
      // console.log(tableItem);

      this.$refs.import.attachRefLayerListener({
        refLayer: refLayer,
        tableItem: tableItem,
      });

      if (tableItem) {
        tableItem["refLayer"] = {
          latlng: latlng,
          layerName: layerName,
          leaflet_id: refLayer._leaflet_id,
          // buildingCsuId: features
        };
      } else if (this.currentSelectedTableItem) {
        this.currentSelectedTableItem["refLayer"] = {
          latlng: latlng,
          layerName: layerName,
          leaflet_id: refLayer._leaflet_id,
        };
      }

      this.saveDataToLocalStorage();
    },

    queryBuildingLayer({ latlng, tableItem }) {
      this.queryLayer({
        layer: 0,
        queryObject: this.buildingLayerQuery,
        latlng: latlng,
        layerName: GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER,
        tableItem: tableItem,
      });
    },

    queryLotLayer({ latlng, tableItem }) {
      this.queryLayer({
        layer: 1,
        queryObject: this.lotLayerQuery,
        latlng: latlng,
        layerName: GLOBAL.MAP_LAYER.NAME.LOT_LAYER,
        tableItem: tableItem,
      });
    },

    queryLayer({ queryObject, layer, latlng, layerName, tableItem }) {
      // console.log({ queryObject, layer, latlng, layerName, tableItem });
      let me = this;
      queryObject
        .layer(layer)
        .contains(L.latLng(latlng))
        .run(function (err, features, response) {
          // console.log(err, features, response);
          if (features.features.length > 0) {
            // console.log(features)
            // let firstFeatures = [];
            // firstFeatures.push(features.features[0]);
            me.attachRefLayerData({
              features: features.features[0],
              latlng: latlng,
              layerName: layerName,
              tableItem: tableItem,
            });
          }
        });
    },

    renderlabelBaseMap() {
      if (this.labelBaseMap) {
        this.map.removeLayer(this.labelBaseMap);
      }

      let layer = null;
      let url =
        this.locate == GLOBAL.LANG.EN ? GLOBAL.MAP_LABEL_URL.EN : GLOBAL.MAP_LABEL_URL.ZH;

      this.labelBaseMap = L.tileLayer(url, {
        id: "mapapi/labelBaseMap",
        KEY: GLOBAL.MAP_KEY,
        zIndex: this.indexlabelBaseMap,
        maxZoom: 20,
      }).addTo(this.map);
    },

    removeControl() {
      if (this.customAttributionControl)
        this.map.removeControl(this.customAttributionControl);

      if (this.customSwitchLayersControl)
        this.map.removeControl(this.customSwitchLayersControl);

      if (this.layersControl) this.map.removeControl(this.layersControl);

      if (this.scaleControl) this.map.removeControl(this.scaleControl);

      if (this.locateControl) this.map.removeControl(this.locateControl);

      if (this.browserPrintControl) this.map.removeControl(this.browserPrintControl);

      if (this.drawControl) this.map.removeControl(this.drawControl);

      if (this.searchBarControl) this.map.removeControl(this.searchBarControl);

      if (this.zoomControl) this.map.removeControl(this.zoomControl);

      if (this.customViewPointControl)
        this.map.removeControl(this.customViewPointControl);
    },

    initControl() {
      let me = this;

      //add custom attribution control
      L.Control.CustomAttributionControl = L.Control.extend({
        options: {
          position: "bottomright",
        },

        initialize: function (name, options) {
          this.name = name;
          L.setOptions(this, options);
        },

        onAdd: function (map) {
          var container = L.DomUtil.create(
            "div",
            "leaflet-bar leaflet-control leaflet-control-custom customAttribution"
          );

          container.style.margin = "0";
          container.style.border = "0";

          return container;
        },

        onRemove: function (map) {},
      });

      this.customAttributionControl = new L.Control.CustomAttributionControl();
      this.map.addControl(this.customAttributionControl);

      //add search control
      this.searchBarControl = L.control.searchBar({ position: "topleft" });
      this.searchBarControl.addTo(this.map);

      //setting layers into map
      let baseMaps = {
        // [this.$t("common.topoLayer")]: this.topoLayer,
        // [this.$t("common.orthoLayer")]: this.orthoLayer,
        ["<span class='switch-layer-text'>" +
        this.$t("common.topoLayer") +
        "</span><span class='switch-layer-topo'>&nbsp;</span>"]: this.topoLayer,
        ["<span class='switch-layer-text'>" +
        this.$t("common.orthoLayer") +
        "</span><span class='switch-layer-ortho'>&nbsp;</span>"]: this.orthoLayer,
      };
      let overlays = {
        // [this.$t("common.lotLayer")]: this.lotLayer,
        // [this.$t("common.buildingLayer")]: this.buildingLayer,
      };

      this.layersControl = L.control.layers(baseMaps, overlays, {
        position: "topleft",
        // collapsed: false,
      });

      this.map.addControl(this.layersControl);

      if (this.enableAddDynamicLayer) {
        this.map.removeControl(this.layersControl);
      }

      //add custom switch layers control
      if (this.enableAddDynamicLayer) {
        this.customSwitchLayersControl = new CustomSwitchLayersControl(
          L,
          {
            position: "topleft",
          },
          { layerText: this.$t("common.title_openLeftBarWithLayer") }
        ).buildControl();
        this.map.addControl(this.customSwitchLayersControl);

        //switch layers listener
        $(".customSwitchLayers").on("click", function (e) {
          // me.chgShowLeftBar(true);
          // me.$refs.leftBar.dynamicTabsModel = 0;
          me.leftBar.openDynamicTab({
            dynamicTab: me.leftBar.dynamicTabs[0],
            showLeftBar: true,
          });
        });
      }

      //ie can't render after remove control
      //add Scale Tool
      this.scaleControl = L.control
        .scale({
          position: "bottomright",
          metric: true,
          imperial: true,
          //    	maxWidth: 100,
        })
        .addTo(this.map);

      //add Locate Tool
      if (this.enableCurrentLocation) {
        if (window.document.documentMode === undefined) {
          this.locateControl = L.control
            .locate({
              position: "bottomright",
              strings: {
                title: this.$t("common.locateTitle"),
              },
              icon: "fa fa-crosshairs",
            })
            .addTo(this.map);
        }
      }

      //add print control
      if (this.enablePrint) {
        this.browserPrintControl = L.control
          .browserPrint({
            title: this.$t("common.printTitle"),
            printModes: [
              L.control.browserPrint.mode.portrait(this.$t("common.printPortrait")),
              L.control.browserPrint.mode.landscape(this.$t("common.printLandscape")),
              L.control.browserPrint.mode.auto(this.$t("common.printAuto")),
              L.control.browserPrint.mode.custom(this.$t("common.printCustom")),
            ],
          })
          .addTo(this.map, {
            position: "topleft",
          });

        //add click listener for ga
        $(".browser-print-mode")[0].addEventListener("click", (e) => {
          me.$GA.print_click();
          this.enableIdentify = true;
        });
        $(".browser-print-mode")[1].addEventListener("click", (e) => {
          this.$GA.print_click();
          this.enableIdentify = true;
        });
        $(".browser-print-mode")[2].addEventListener("click", (e) => {
          this.$GA.print_click();
          this.enableIdentify = true;
        });
        $(".browser-print-mode")[3].addEventListener("click", (e) => {
          this.$GA.print_click();
          this.enablePrintCustom = true;
        });
      }

      this.renderAttribution();

      this.initDraw();

      this.customViewPointControl = new CustomViewPointControl(
        L,
        {
          position: "topleft",
        },
        { title: this.$t("common.viewPoint") }
      ).buildControl();
      this.map.addControl(this.customViewPointControl);

      //customViewPointControl listener
      $(".customViewPointControl").on("click", function (e) {
        // me.chgShowLeftBar(true);
        // me.$refs.leftBar.dynamicTabsModel = 0;
        me.map.setView(me.mapDefaultExtent, me.minZoom);
      });

      this.initZoom();
      this.renderlabelBaseMap();
    },

    initZoom() {
      this.zoomControl = L.control
        .zoom({
          zoomInTitle: this.$t("common.zoomIn"),
          zoomOutTitle: this.$t("common.zoomOut"),
          position: "topleft",
        })
        .addTo(this.map);
    },

    initDraw() {
      //add Draw Tool

      this.drawControl = new L.Control.Draw({
        draw: {
          polygon: false,
          polyline: false,
          rectangle: false,
          circle: false,
          marker: {
            // repeatMode: true,
          },
        },
        edit: {
          featureGroup: this.drawnItems,
          edit: true,
        },
      });

      // console.log(this.drawControl)

      //localization draw

      L.drawLocal = {
        draw: {
          toolbar: {
            // #TODO: this should be reorganized where actions are nested in actions
            // ex: actions.undo  or actions.cancel
            actions: {
              title: this.$t("common.actionsTitle"),
              text: this.$t("common.actions"),
            },
            finish: {
              title: this.$t("common.finishTitle"),
              text: this.$t("common.finish"),
            },
            undo: {
              title: this.$t("common.undoTitle"),
              text: this.$t("common.undo"),
            },
            buttons: {
              polyline: this.$t("common.drawAPolyLine"),
              polygon: this.$t("common.drawAPolygon"),
              rectangle: this.$t("common.drawARectangle"),
              circle: this.$t("common.drawACircle"),
              marker: this.$t("common.drawAMarker"),
              // circlemarker: "circlemarker?",
            },
          },
          handlers: {
            circle: {
              tooltip: {
                start: this.$t("common.drawCircleTooltipStart"),
              },
              radius: this.$t("common.radius"),
            },
            // circlemarker: {
            //   tooltip: {
            //     start: "- your text-.",
            //   },
            // },
            marker: {
              tooltip: {
                start: this.$t("common.drawMarkerTooltipStart"),
              },
            },
            polygon: {
              tooltip: {
                start: this.$t("common.drawPolygonTooltipStart"),
                cont: this.$t("common.drawPolygonTooltipCont"),
                end: this.$t("common.drawPolygonTooltipEnd"),
              },
            },
            polyline: {
              error: "<strong>Error:</strong> shape edges cannot cross!",
              tooltip: {
                start: this.$t("common.drawPolylineTooltipStart"),
                cont: this.$t("common.drawPolylineTooltipCont"),
                end: this.$t("common.drawPolylineTooltipEnd"),
              },
            },
            rectangle: {
              tooltip: {
                start: this.$t("common.drawRectangleTooltipStart"),
              },
            },
            simpleshape: {
              tooltip: {
                end: this.$t("common.drawSimpleShapeTooltipEnd"),
              },
            },
          },
        },
        edit: {
          toolbar: {
            actions: {
              save: {
                title: this.$t("common.saveTitle"),
                text: this.$t("common.save"),
              },
              cancel: {
                title: this.$t("common.cancelTitle"),
                text: this.$t("common.cancel"),
              },
              clearAll: {
                title: this.$t("common.clearAllTitle"),
                text: this.$t("common.clearAll"),
              },
            },
            buttons: {
              edit: this.$t("common.drawEditButton"),
              editDisabled: this.$t("common.drawEditDisabled"),
              remove: this.$t("common.drawRemove"),
              removeDisabled: this.$t("common.drawRemoveDisabled"),
            },
          },
          handlers: {
            edit: {
              tooltip: {
                text: this.$t("common.drawHandlerEditTooltip"),
                subtext: this.$t("common.drawHandlerEditTooltipSubtext"),
              },
            },
            remove: {
              tooltip: {
                text: this.$t("common.drawHandlerRemoveTooltip"),
              },
            },
          },
        },
      };

      this.map.addControl(this.drawControl);
    },

    showLoadDataModal() {
      let me = this;
      me.loadFromPreviousData();
    },

    reloadTableItemAndLayer(item) {
      //for csv without latitude & longitude
      if (item.hasOwnProperty("geojson") && item.geojson !== null) {
        //for layer and marker
        //L.geoJson is a FeatureGroup
        let geojsonlayer = L.geoJson(item.geojson, {
          ...this.$refs.import.attachOrginalLayerOptions(),
        });

        let layer = geojsonlayer.getLayers()[0];

        item.leaflet_id = layer._leaflet_id;
        this.attachDrawnMarkerToMap(layer);
      }

      //for ref layer
      if (item.refLayer) {
        let refLayer = item.refLayer;
        // console.log(refLayer.latlng)
        switch (refLayer.layerName) {
          case GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER:
            this.queryBuildingLayer({
              latlng: refLayer.latlng,
              tableItem: item,
            });
            break;
          case GLOBAL.MAP_LAYER.NAME.LOT_LAYER:
            this.queryLotLayer({
              latlng: refLayer.latlng,
              tableItem: item,
            });
            break;
        }
      }
    },

    reloadTableItemsAndLayers() {
      this.drawnItems.clearLayers();

      for (let i = 0; i < this.tableItems.length; i++) {
        let item = this.tableItems[i];
        this.reloadTableItemAndLayer(item);
      }
    },

    async loadFromPreviousData() {
      let result = await this.isExistingLocalStorageAndImportData(true);

      if (result) {
        this.reloadTableItemsAndLayers();
      }

      this.extentDrawnItemBounds();
    },

    async isExistingLocalStorageAndImportData(isImportData) {
      isImportData = isImportData || false;

      let tableItems = [];
      let dynamicFields = [];
      let dynamicLayers = [];

      // console.log(this.checkLocalforageSupport())

      if (this.checkLocalforageSupport()) {
        tableItems = (await localforage.getItem("tableItems")) || [];
        dynamicFields = (await localforage.getItem("dynamicFields")) || [];
        dynamicLayers = (await localforage.getItem("dynamicLayers")) || [];
      }

      if (tableItems.length > 0 || dynamicFields.length > 0 || dynamicLayers.length > 0) {
        if (isImportData) {
          // console.log("isImportData");
          this.tableItems = tableItems;
          this.dynamicFields = dynamicFields;
          this.dynamicLayers = dynamicLayers;
        }

        return true;
      }

      return false;
    },

    clearLocalStorage() {
      // console.log("clearLocalStorage")
      if (this.checkLocalforageSupport()) {
        // console.log("clearLocalStorage")
        localforage.removeItem("tableItems");
        localforage.removeItem("dynamicFields");
        // this.loadLocalStorageSpace();
      }
    },

    saveDataToLocalStorage() {
      if (!this.enableStartSaveToLocalStorage) {
        return false;
      }

      if (this.checkLocalforageSupport()) {
        if (this.enableSaveToLocalStorage) {
          this.updateLocalStorageRecord("tableItems", this.tableItems);
          this.updateLocalStorageRecord("dynamicFields", this.dynamicFields);
          this.updateLocalStorageRecord("dynamicLayers", this.dynamicLayers);

          let date = new Date();
          let dateString = `${date.getFullYear()}-${this.convertTo2Digits(
            date.getMonth() + 1
          )}-${this.convertTo2Digits(date.getDate())} ${this.convertTo2Digits(
            date.getHours()
          )}:${this.convertTo2Digits(date.getMinutes())}:${this.convertTo2Digits(
            date.getSeconds()
          )}`;

          this.$emit("setSavedMessage", dateString);
        } else {
          this.clearLocalStorage();
        }
      }
    },

    convertTo2Digits(val) {
      return ("0" + val).slice(-2);
    },

    //labelAddstring: avoid crash label
    // addColumn(newColumnName, labelAddstring, newColumnType) {
      addColumn(newColumnName, newColumnType) {

      // console.log("addColumn", newColumnName, labelAddstring, newColumnType)

      // labelAddstring = labelAddstring || "";

      //for general existing
      if (
        this.isNotHiddenField(newColumnName) &&
        !this.isExistingDynamicField(newColumnName)
      ) {
        this.dynamicFields.push({
          // key: "" + Date.now() + labelAddstring,
          key: newColumnName,
          label: newColumnName,
          type: newColumnType ? newColumnType : GLOBAL.FIELD_TYPES.TEXTAREA,
          tdClass: "data_content_td",
          sortable: true,
        });

        this.showNewSnackBar(
          this.$t("common.insert") +
            " " +
            this.$t("common.column") +
            " " +
            this.$t("common.successfully")
        );

        this.newColumnName = "";

        if (this.manageColumnModal) {
          // console.log(this)
          this.table_container.$refs.newColumnNameForm.resetValidation();
        }
      }
    },

    //add column for new column modal on table tool
    addColumnByModal(newColumnName) {
      // console.log("addColumnByModal", newColumnName);
      if (
        !(typeof this.validNewColumnNameState === "string") &&
        this.validNewColumnNameState
      ) {
        this.addColumn(newColumnName);
        let me = this;
        this.$nextTick(() => {
          // setTimeout(() => {
          me.table_container.$refs[this.dynamicFields.length - 1][0].scrollIntoView();
          // }, 100);
        });
      }
    },

    //for add layers to map
    addLayersToFeatureGroup(layers) {
      if (layers.length > 0) {
        for (let i = 0; i < layers.length; i++) {
          this.attachDrawnMarkerToMap(layers[i]);
        }
      }
    },

    //for csv import without layer
    addItemsToTableDataByCSVWithoutLayer(csv_headers, csv_items) {
      for (let i = 0; i < csv_headers.length; i++) {
        // this.addColumn(csv_headers[i], i + "");
        this.addColumn(csv_headers[i]);
      }

      for (let i = 0; i < csv_items.length; i++) {
        this.tableItems.push({
          index: this.tableItems.length + 1,
          leaflet_id: null,
          geojson: null,
          item: csv_items[i],
        });
      }

      if (this.tableItems.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    // for update items
    addItemToTableData(layer, layerType, _isAddTocurrentSelectedTableItem) {
      // console.log("addItemToTableData");
      let isAddTocurrentSelectedTableItem = _isAddTocurrentSelectedTableItem || false;

      let geoJSON = layer.toGeoJSON();
      if (layerType === GLOBAL.LAYER_TYPE.CIRCLE) {
        geoJSON.properties[this.GLOBAL.HIDDEN_FIELD_LABELS.RADIUS] = layer.getRadius();
      }

      //check each layer properties
      if (geoJSON.properties) {
        let list = Object.keys(geoJSON.properties);

        for (let i = 0; i < list.length; i++) {
          // this.addColumn(list[i], list[i]);
          this.addColumn(list[i]);
        }
      }

      // //add default columns if there is no column
      // if (this.dynamicFields.length == 0 && this.tableItems.length == 0) {
      //   this.defaultDynamicFields.forEach((defaultDynamicField, index) => {
      //     this.addColumn(defaultDynamicField, index.toString());
      //   });
      // }
      // this.addSpecialFieldTypesColumn()

      if (isAddTocurrentSelectedTableItem) {
        let tableItem = this.tableItems.find((tableItem) => {
          if (tableItem.index == this.currentSelectedTableItem.index) {
            return true;
          }
        });

        if (tableItem) {
          tableItem.leaflet_id = layer._leaflet_id;
          tableItem.geojson = geoJSON;
          tableItem.geojson.properties = tableItem.item;
          this.updateTableLayerProperties(tableItem.item, layer._leaflet_id);
          tableItem.item = null;
          return tableItem;
        } else {
          return null;
        }
      } else {
        let item = {
          index: this.tableItems.length + 1,
          leaflet_id: layer._leaflet_id,
          geojson: geoJSON,
          item: null,
        };
        this.tableItems.push(item);
        return item;
      }
    },

    // addSpecialFieldTypesColumn() {
    //   this.defaultDynamicFields.forEach((defaultDynamicField, index) => {
    //     this.addColumn(defaultDynamicField, index.toString());
    //   });
    // },

    renderLatLngs(table_data_item) {
      let resultString = "";
      let coordinates = table_data_item.item.geojson.geometry.coordinates;
      for (let i = 0; i < coordinates.length; i++) {
        resultString += coordinates[i].toString() + "<br>";
      }
      return resultString;
    },

    //for editing to update item

    updateTableItemGeoJSON(layer) {
      for (let i = 0; i < this.tableItems.length; i++) {
        let tmpTableItem = this.tableItems[i];
        if (tmpTableItem.leaflet_id == layer._leaflet_id) {
          let geoJSON = layer.toGeoJSON();

          if (typeof layer.getRadius !== "undefined") {
            geoJSON.properties[
              this.GLOBAL.HIDDEN_FIELD_LABELS.RADIUS
            ] = layer.getRadius();
          }

          tmpTableItem.geojson = geoJSON;
          tmpTableItem.item = null;

          //remove auto match attribute
          delete tmpTableItem.automatched;
          delete tmpTableItem.automatchedxy;

          break;
        }
      }
    },

    updateTableDataByListener(data, event) {
      for (let i = 0; i < this.tableItems.length; i++) {
        let tmpTableItem = this.tableItems[i];
        // console.log(tmpTableItem);
        if (
          (data.item.leaflet_id == null ||
            data.item.geojson == null ||
            tmpTableItem.leaflet_id === data.item.leaflet_id) &&
          tmpTableItem.index === data.item.index
        ) {
          for (let j = 0; j < this.dynamicFields.length; j++) {
            let field = this.dynamicFields[j];
            if (field.key === data.field.key) {
              if (
                tmpTableItem.hasOwnProperty("geojson") &&
                tmpTableItem.geojson &&
                tmpTableItem.geojson.hasOwnProperty("properties")
              ) {
                if (!tmpTableItem.geojson.properties) {
                  tmpTableItem.geojson.properties = {};
                }
                tmpTableItem.geojson.properties[field.label] = event.target.value;

                this.updateTableLayerProperties(
                  tmpTableItem.geojson.properties,
                  tmpTableItem.leaflet_id
                );
              } else {
                if (!tmpTableItem.hasOwnProperty("item") || tmpTableItem.item == null) {
                  tmpTableItem["item"] = {};
                }

                tmpTableItem.item[field.label] = event.target.value;
              }
            }
          }
        }
      }

      this.saveDataToLocalStorage();
    },

    removeAllColumns() {
      this.clearConfirmDialog();
      this.confirmDialogOK = () => {
        const items = this.tableItems.map((v)=>{
          for (const field of this.dynamicFields) {
            if (v.geojson) delete v.geojson.properties[field.label];
            if (v.item) delete v.item[field.label];
          }
          return v;
        });
        this.dynamicFields = [];
      }
      this.confirmDialogMessage = this.$t("common.confirmToDeleteAllColumns");
      this.confirmDialog = true;
    },

    removeColumnData(dynamicField) {
      this.clearConfirmDialog();

      this.confirmDialogPersistent = false;
      this.currentDeleteDynamicField = dynamicField;
      this.confirmDialog = true;
      this.confirmDialogMessage = this.$t(
        "common.confirmToDeleteColAndRelatedRecordMessage"
      );
      this.confirmDialogOK = this.removeColumnData2;
    },

    removeColumnData2() {
      for (let i = 0; i < this.dynamicFields.length; i++) {
        if (this.currentDeleteDynamicField.key === this.dynamicFields[i].key) {
          this.dynamicFields.splice(i, 1);

          this.showNewSnackBar(
            this.$t("common.remove") +
              " " +
              this.$t("common.column") +
              " " +
              this.$t("common.successfully")
          );

          for (let j = 0; j < this.tableItems.length; j++) {
            // console.log(this.tableItems[j]);
            let item = this.tableItems[j];

            //skip empty case
            // if (!item.geojson && !item.item) {
            //   continue;
            // }

            if (item.geojson) {
              try {
                delete item.geojson.properties[this.currentDeleteDynamicField.label];
              } catch (e) {
                console.log(e)
              }
            }

            if (item.item) {
              try {
                delete item.item[this.currentDeleteDynamicField.label];
              } catch (e) {
                console.log(e)
              }
            }

            // ted - 20230706 - export error
            /* triggle error
            step 1: one record with xy. one record is empty
            step 2: create field name '123' and xy record with value at this field
            step 3: delete '123' field
            step 4: export gml

            */

            // try {
            //   // console.log(this.currentDeleteDynamicField, item)
            //   delete item.geojson.properties[this.currentDeleteDynamicField.label];
            // } catch (e) {
            //   try {
            //     delete item.item[this.currentDeleteDynamicField.label];
            //   } catch (e) {
            //     // throw "Can't Delete Column's Data";
            //   }
            // }
          }

          break;
        }
      }
    },

    attachDrawnMarkerToMap(layer, type) {
      this.drawnItems.addLayer(this.import.attachTableLayerListener(layer, type));
    },

    //for enable marker function for table list item
    enableAddLayerReference(item) {
      let me = this,
        leftBar = this.$refs.leftBar;

      this.setShowTable({ val: false });

      setTimeout(() => {
        let presetLayerSelected = leftBar.$refs.leftBarLayers.presetLayerSelected;
        if (!presetLayerSelected || presetLayerSelected == "") {
          leftBar.$refs.leftBarLayers.setPresetLayerSelected(
            GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER
          );
        }
      }, 1000);
    },

    //for remove all items
    removeTableDatas({ withColumns }) {
      let me = this,
        _withColumns = withColumns || false;
      this.clearConfirmDialog();
      this.confirmDialogPersistent = false;
      this.confirmDialogOK = () => {
        me.tableItemsRefLayerDrawnItems.clearLayers();
        me.drawnItems.clearLayers();
        me.tableItems = [];
        if (_withColumns) {
          me.dynamicFields = [];
        }

        me.showNewSnackBar(
          me.$t("common.remove") +
            " " +
            (_withColumns
              ? me.$t("common.allRecordAndCols")
              : me.$t("common.allRecord")) +
            " " +
            me.$t("common.successfully")
        );
        me.saveDataToLocalStorage();
      };
      this.confirmDialogMessage = this.$t(
        _withColumns
          ? "common.confirmToDeleteAllRecordAndColsMessage"
          : "common.confirmToDeleteAllRecordMessage"
      );
      this.confirmDialog = true;
    },

    // for remove item
    removeTableDataByTableItem(item) {
      this.updateCurrentSelectedTableItem({ tableItem: item });
      // this.currentSelectedTableItem = item;

      this.clearConfirmDialog();
      this.confirmDialogPersistent = false;
      this.confirmDialogOK = this.removeTableDataByCurrentSelectedTableItem_confirmed;
      this.confirmDialogMessage = this.$t("common.confirmToDeleteRecordMessage");
      this.confirmDialog = true;
    },

    removeTableItemByLeafletId(leaflet_id) {
      let item = this.tableItems.find((tableItem) => {
        return tableItem.leaflet_id == leaflet_id;
      });
      if (item) {
        this.drawnItems.removeLayer(item.leaflet_id);
        this.updateCurrentSelectedTableItem({ tableItem: item });
        this.removeTableDataByCurrentSelectedTableItem_confirmed();
      }
    },

    removeTableDataByCurrentSelectedTableItem_confirmed() {
      this.$GA.t_confirmed_delete_table_item_data();

      let deleteLeafletId = null,
        deleteRefLayerLeafletId = null;

      // remove row into items
      let re_arrange = false;
      for (let i = 0; i < this.tableItems.length; i++) {
        let tmpTableItem = this.tableItems[i];
        // console.log(tmpTableItem, this.currentSelectedTableItem);
        if (
          (this.currentSelectedTableItem &&
            tmpTableItem.index === this.currentSelectedTableItem.index) ||
          (this.currentSelectedTableItem &&
            tmpTableItem.leaflet_id === this.currentSelectedTableItem._leaflet_id) ||
          (!this.currentSelectedTableItem &&
            tmpTableItem.leaflet_id === this.currentSelectedSearchResultLeafletId)
        ) {
          deleteLeafletId = this.tableItems[i].leaflet_id;
          if (this.tableItems[i].refLayer) {
            deleteRefLayerLeafletId = this.tableItems[i].refLayer.leaflet_id;
          }

          this.tableItems.splice(i, 1);
          re_arrange = true;
          i--;
          continue;
        }

        if (re_arrange) {
          tmpTableItem.index--;
        }
      }

      if (deleteLeafletId) {
        this.drawnItems.removeLayer(deleteLeafletId);
      }

      if (deleteRefLayerLeafletId) {
        this.tableItemsRefLayerDrawnItems.removeLayer(deleteRefLayerLeafletId);
      }

      this.showNewSnackBar(
        this.$t("common.remove") +
          " " +
          this.$t("common.record") +
          " " +
          this.$t("common.successfully")
      );

      this.$forceUpdate();
      // this.currentSelectedTableItem = null;
      this.saveDataToLocalStorage();
    },

    //for button to delete all data on table tools
    deleteAllData(_deleteColumns) {
      let deleteColumns = _deleteColumns || false;

      this.$GA.t_confirmed_delete_all_data();

      this.tableItems.splice(0, this.tableItems.length);

      if (deleteColumns) {
        this.dynamicFields.splice(0, this.dynamicFields.length);
      }

      let drawnItems = this.drawnItems;
      drawnItems.eachLayer(function (layer) {
        drawnItems.removeLayer(layer);
      });
    },

    updateEnableSaveToLocalStorage(value) {
      // console.log(value);
      this.enableSaveToLocalStorage = value;
      if (this.checkLocalforageSupport()) {
        localforage.setItem("enableSaveToLocalStorage", value);
        this.updateLocalStorageRecord("enableSaveToLocalStorage", value);
      }
    },

    updateLocalStorageRecord(key, val) {
      localforage.setItem(key, val);
      // this.loadLocalStorageSpace();
    },

    setShowTable({ val, openFromAutoCSVMatch }) {
      this.notShowTableTour =
        openFromAutoCSVMatch || this.import.loadingDialog.visible ? true : false;
      this.showTable = val;
      this.setResizeElementTimer(0);

      // //Show table tour when table is shown via Import for the first time
      // if (
      //   $cookies.get("showTableTourFromImport") !== null &&
      //   ($cookies.get("showTableTour") !== false ||
      //     $cookies.get("showTableTour") == null)
      // ) {
      //   setTimeout(() => {
      //     this.tour.showTableTour({});
      //     $cookies.get("showTableTourFromImport") == null;
      //   }, 400);
      // }
    },

    clickShowTable() {
      const map = this.map;

      this.showTable = !this.showTable;
      this.setResizeElementTimer(0);
    },

    existDynamicFieldType(type) {
      return this.dynamicFields.find((dynamicField) => type == dynamicField.type);
    },

    setResizeElementTimer(_duration) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.resizeElements(_duration);
      }, _duration);
    },

    resizeElements(_duration) {
      // let duration = _duration || 0,
      let searchBar = $("#searchBar"),
        appBar = $("#appBar"),
        leftBar = $("#leftBar"),
        leftBarSlider = $("#leftBarSlider"),
        // leftBarTabs = $("#leftBarTabs"),
        // leftBarTabsItemToolBar = $(".leftBarTabsItemToolBar"),
        customSwitchLayersContainer = $(".customSwitchLayersContainer"),
        switchLayersContainer = $(".leaflet-control-layers"),
        tableSlider = $("#tableSlider"),
        data_container = $("#data_container"),
        data_content = $("#data_content");

      const map = this.map;

      // const resetMap = {
      //   duration: duration,
      //   complete() {
      //     map.invalidateSize();
      //   },
      //   progress() {
      //     map.invalidateSize();
      //   },
      // };

      if (!this.showLeftBar) {
      //   // console.log("1")
      //   leftBar.css({
      //     width: 0,
      //   });
      } else {
        leftBar.css({
      //     width:
      //       (this.leftBarSliderWidthPercent * $(window).width()) / 100
      //         ? (this.leftBarSliderWidthPercent * $(window).width()) / 100
      //         : this.leftBarWidth,
          maxWidth: this.leftBarMaxWidth,
          minWidth: this.leftBarMinWidth,
      //     // height: $(window).height() - appBar.height(),
        });
      }

      leftBarSlider.css({
        left: leftBar.width() - leftBarSlider.width() / 2,
      });

      $("#data_menu").css({
        left:
          (switchLayersContainer.width() || customSwitchLayersContainer.width()) +
          (this.showLeftBar ? leftBar.width() : 0) +
          20,
      });

      data_container.css({
        left: this.showLeftBar ? leftBar.width() : 0,
        width: this.showLeftBar ? appBar.width() - leftBar.width() : appBar.width(),
      });

      if (!this.showTable) {
        // console.log("1")
        data_content.css({
          height: "0vh",
        });
      } else {
        let newHeight = (this.tableSliderHeightPercent * $(window).height()) / 100;
        if (newHeight > $(window).height() - appBar.height()) {
          newHeight = $(window).height() - appBar.height();
        }

        data_content.css({
          height: newHeight ? newHeight : ($(window).height() - appBar.height()) * 0.5,
          maxHeight: $(window).height() - appBar.height() - tableSlider.height() / 2 - 20,
        });
      }

      tableSlider.css({
        top: -tableSlider.height() / 2,
      });

      $("#map").css({
        left: this.showLeftBar ? leftBar.width() : 0,
        width: this.showLeftBar ? appBar.width() - leftBar.width() : appBar.width(),
        height: $(window).height() - appBar.height() - data_content.height(),
      });

      // console.log($(".leftBarTabsItemContent"))

      $("#switchLayersControlForm").css({
        left:
          (this.showLeftBar ? leftBar.width() : 0) +
          customSwitchLayersContainer.width() +
          20,
        maxHeight:
          $(window).height() -
          appBar.height() -
          searchBar.height() -
          $("#data_menu").height() -
          30,
        maxWidth: appBar.width() * 0.8,
      });

      map.invalidateSize();
    },

    // Avoid closing dialog quickly problem when tour is running
    setDialogPersistent() {
      this.tour_intervalID = setInterval(() => {
        if ($("#driver-popover-item").length == 0) {
          //if ($(".driver-fix-stacking").length == 0) {
          this.notAllowBackdropClose = false;
          clearInterval(this.tour_intervalID);
          this.tour_intervalID = null;
        } else {
          this.notAllowBackdropClose = true;
        }
      }, 1000);
    },

    checkDuplicatedFieldname() {
      const resultList = [];
      const columnTest = new Set();
      const errorList = new Set();
      this.dynamicFields.forEach((element, i) => {
        if (!columnTest.has(element.label.toUpperCase()))
          columnTest.add(element.label.toUpperCase());
        else
          errorList.add(element.label.toUpperCase());
      });

      errorList.forEach((errItem) => {
        this.dynamicFields.forEach((field, i) => {
          if (field.label.toUpperCase() == errItem) {
            resultList.push({no: i+1, field: field.label});
          }
        });
      });
      return resultList;
    },
  },
};
</script>

<style lang="sass">
a.leaflet-control-zoom-in, a.leaflet-control-zoom-out
  &:hover
    text-decoration: none !important
</style>

<style scoped lang="sass">
#map_container
  position: fixed
  height: 100%
  width: 100%
#map
  height: 100%
#disselect_table_item
  margin: 5px 0px
</style>
